import React from 'react'

export const MapDesktop = () => {
  return (
    <svg
      width="918"
      height="640"
      viewBox="0 0 918 640"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M52.0239 30.8156C42.1228 23.1349 67.5482 -13.489 67.5482 -13.489L276.258 -30.95L647.056 -73.1184L815.447 -89.5155L902.729 -85.6178C902.729 -85.6178 1046.9 -49.9926 1042 -38.9662C1039.65 -33.681 1030.27 -14.6346 1016.99 6.31997C1010.86 15.9993 1000.7 26.429 995.74 35.4823C995.065 36.7147 993.729 38.5707 992.428 40.3795L989.395 44.8645C989.793 53.0098 985.332 64.1855 984.982 65.9458C984.547 68.1354 983.492 69.0601 981.495 68.8379C979.051 68.566 974.487 75.2345 971.716 72.9447C969.173 70.8425 967.353 67.0721 966.323 64.6865C965.807 63.492 963.749 53.1457 963.845 51.1032C963.98 48.1918 967.028 44.5169 967.883 40.9265C969.998 32.0473 973.422 24.3262 973.422 24.3262L933.297 75.7302L908.923 41.0873L886.782 33.5514L882.218 88.6601L820.535 116.624L815.881 151.325L751.277 221.616L708.411 235.505L638.437 251.627L552.105 146.53L550.424 112.138L502.457 114.483L501.838 101.813L466.807 108.969L276.483 112.83L171.354 105.722L88.2214 93.9106C88.2214 93.9106 61.925 38.4964 52.0239 30.8156Z"
          fill="#E3F2F0"
        />
        <path
          d="M224.214 648.819C206.113 649.704 203.181 667.05 206.157 650.609C209.352 632.961 179.971 576.185 163.85 527.484C154.27 498.542 137.888 487.527 132.829 468.218L160.731 463.679L182.761 468.952L197.817 480.009L295.487 501.543L300.132 494.512L332.018 487.964L374.207 534.437L402.144 558.472L404.526 532.954L440.948 535.71L497.583 571.497L523.5 618.5L523.5 660.5L251.908 667.877C236.107 641.585 219.301 594.718 217.243 589.738C214.795 583.815 180.361 511.687 176.878 501.594C177.767 506.168 180.752 522.834 186.212 539.545C197.138 572.984 214.062 618.782 224.214 648.819Z"
          fill="#E3F2F0"
        />
      </g>
      <g opacity="0.8">
        <path
          d="M693.691 475.119L704.688 471.326L742.116 462.387L741.102 460.863L739.144 458.259L738.76 454.375L738.294 450.55L736.274 446.703L735.58 439.211L737.591 434.856L735.265 431.697L730.889 425.441L721.318 404.948L710.377 379.677L687.937 384.597L666.323 389.294L668.118 392.559L668.127 392.704L670.844 421.657L674.864 457.242L682.276 490.008L698.605 488.919L699.197 486.183L699.245 482.044L693.783 477.674L693.691 475.119Z"
          fill="#0C6776"
        />
        <path
          d="M629.616 379.582L632.424 376.771L633.536 373.631L633.454 372.691L621.515 374.95L622.571 371.353L625.438 366.294L623.988 364.521L603.995 366.795L585.343 369.946L565.71 372.972L544.852 375.668L551.425 397.817L554.022 419.33L556.156 438.503L556.917 439.353L560.071 438.643L564.431 438.104L565.16 438.015L565.885 450.693L583.118 448.162L603.267 444.172L618.516 442.289L618.626 438.597L615.513 433.243L614.988 427.671L617.663 419.167L618.805 414.212L621.665 410.42L623.368 408.938L624.641 402.984L624.08 399.52L627.059 397.24L627.064 396.614L626.238 396.772L627.074 395.565L627.08 395.216L627.349 395.158L628.696 393.216L627.284 386.891L629.62 383.407L629.616 379.582Z"
          fill="#0C6776"
        />
        <path
          d="M260.237 379.361L226.01 377.645L197.953 376.053L196.729 393.532L195.79 394.288L194.122 398.057L191.106 396.703L187.856 394.89L184.665 394.629L183.58 396.581L184.873 399.598L184.452 404.538L184.465 408.776L185.009 413.306L183.524 417.58L183.704 419.394L184.449 422.438L185.619 426.372L187.601 430.645L191.101 435.709L184.786 440.068L182.499 450.019L178.539 454.708L179.126 458.396L179.492 461.592L182.726 465.145L179.823 470.241L177.341 469.999L175.784 473.08L202.887 485.84L245.444 503.986L282.678 505.109L285.428 380.278L260.237 379.361Z"
          fill="#0C6776"
        />
        <path
          d="M176.554 468.54L179.077 468.785L181.042 465.321L178.183 462.186L177.768 458.574L177.092 454.295L181.244 449.38L183.58 439.228L189.198 435.351L186.387 431.276L184.316 426.81L183.127 422.789L182.36 419.626L182.168 417.782L154.596 386.993L126.08 354.184L97.1144 319.814L106.574 254.171L38.8823 242.687L35.9402 260.993L28.9251 278.13L35.5517 291.656L34.5606 309.911L44.4184 330.425L50.9806 339.224L49.4509 344.332L58.9231 377.009L72.891 401.928L73.278 414.233L77.0786 418.163L91.3195 421.934L98.3409 429.97L105.592 431.758L123.905 447.62L130.597 460.22L131.886 468.193L152.885 468.719L176.525 468.583L176.554 468.54Z"
          fill="#0C6776"
        />
        <path
          d="M342.22 379.265L372.514 378.627L393.843 377.846L406.613 377.273L410.288 377.109L408.551 345.203L406.466 310.301L405.365 289.402L373.095 290.818L373.096 290.826L372.408 290.845L371.722 290.879L371.72 290.863L355.524 291.311L321.746 291.7L304.85 291.598L288.634 291.342L286.826 378.927L314.045 379.305L342.22 379.265Z"
          fill="#0C6776"
        />
        <path
          d="M878.376 162.509L867.019 166.541L872.001 181.899L874.336 183.466L871.552 187.006L872.368 188.238L882.257 179.025L890.918 174.396L896.971 170.816L896.727 167.947L892.302 157.433L878.376 162.509Z"
          fill="#0C6776"
        />
        <path
          d="M853.721 232.291L853.607 232.362L853.284 231.703L851.264 227.523L852.47 225.224L850.128 225.331L849.28 226.441L848.745 228.179L859.142 253.589L868.507 250.199L860.821 241.845L853.721 232.291Z"
          fill="#0C6776"
        />
        <path
          d="M168.106 163.482L169.159 167.057L168.611 170.883L171.615 175.276L174.173 177.474L174.724 181.459L172.717 184.384L170.012 189.846L166.947 196.879L163.022 200.922L160.343 205.528L159.975 208.505L162.638 210.235L163.762 213.728L161.614 220.024L157.073 259.055L187.028 261.966L205.872 263.795L254.653 266.572L257.074 212.206L256.823 212.01L256.384 211.673L256.383 211.665L254.983 210.577L253.614 207.471L252.733 207.108L250.374 211.204L246.223 211.791L237.812 210.014L237.256 212.185L231.775 210.985L228.171 214.332L225.347 207.424L223.768 204.392L220.571 203.613L219.519 201.516L218.941 195.706L216.361 192.732L215.069 185.459L213.58 182.57L212.511 182.124L210.9 184.765L207.02 187.585L203.75 184.54L204.091 178.14L205.953 176.898L205.167 171.309L207.198 165.385L208.957 161.361L205.013 160.851L201.062 157.021L197.358 149.619L195.214 146.088L191.904 143.649L189.221 139.493L189.619 135.425L186.233 129.097L187.345 105.841L174.111 104.474L171.087 132.436L168.106 163.482Z"
          fill="#0C6776"
        />
        <path
          d="M637.498 230.348L636.281 225.226L624.42 227.524L607.528 230.858L592.134 233.749L592.419 234.088L592.514 234.198L594.714 234.994L595.938 237.24L598.748 238.506L601.036 240.29L601.277 246.798L599.115 252.445L598.201 254.473L594.388 256.57L589.275 258.533L588.638 261.705L590.769 262.924L592.263 266.656L590.7 271.02L590.163 274.683L586.518 278.62L586.809 282.011L586.887 282.051L586.853 282.436L586.961 283.658L586.751 283.537L586.341 288.029L588.863 294.064L592.341 297.953L596.134 301.023L600.505 303.235L602.428 304.016L604.784 308.293L605.623 311.512L607.05 311.89L610.171 309.78L614.762 313.2L614.503 317.934L613.523 321.358L613.163 325L615.919 327.555L619.647 329.821L621.657 329.528L627.204 333.529L629.283 333.861L631.822 339.366L631.823 342.704L634.645 346.94L636.247 346.087L638.369 347.639L637.901 346.535L638.896 343.433L644.437 343.724L648.65 344.778L650.034 343.14L648.338 338.417L652.291 335.466L654.365 333.76L652.693 332.234L654.099 328.579L653.835 327.685L653.728 327.673L653.681 327.151L653.438 326.288L653.618 326.298L653.302 322.374L654.514 315.859L656.997 310.448L657.46 306.518L658.547 304.973L658.111 302.46L658.104 302.404L656.518 299.121L654.6 297.706L655.231 290.962L644.355 240.833L637.498 230.348Z"
          fill="#0C6776"
        />
        <path
          d="M693.482 250.614L688.418 230.05L673.855 233.701L656.507 237.618L652.654 240.987L646.691 242.436L646.014 242.015L656.614 290.871L656.036 297.056L657.598 298.214L659.44 302.066L659.988 305.296L658.785 307.019L658.286 310.921L655.796 316.348L654.665 322.528L654.993 326.346L655.914 326.38L655.564 323.84L660.934 324.655L664.169 321.41L669.958 323.466L670.625 321.541L674.578 318.193L678.626 319.819L679.697 317.553L682.14 311.408L684.419 314.646L687.441 315.456L689.566 308.505L691.833 307.246L693.14 303.107L695.028 301.074L694.321 296.41L698.98 296.191L701.105 293.699L703.718 293.015L703.926 291.926L701.386 287.744L702.16 286.367L693.482 250.614Z"
          fill="#0C6776"
        />
        <path
          d="M659.302 499.996L658.565 498.007L657.26 494.698L654.332 492.667L652.366 489.789L652.96 485.737L652.833 482.829L635.716 485.979L618.217 488.323L616.229 482.076L618.217 479.065L618.997 473.602L619.917 468.495L622.919 464.467L623.041 460.14L625.01 457.707L622.117 454.56L622.408 451.682L618.845 447.568L619.931 444.22L619.03 443.623L603.492 445.533L583.368 449.529L566.062 452.068L570.419 474.552L573.796 476.544L575.436 480.006L577.798 484.859L580.705 489.516L582.989 492.469L582.293 501.284L581.44 503.817L580.624 508.91L582.15 510.105L582.824 515.098L580.248 518.62L578.939 521.736L580.491 523.812L597.118 521.973L612.459 522.507L624.39 525.186L641.56 526.797L666.993 521.131L658.86 509.705L659.302 499.996Z"
          fill="#0C6776"
        />
        <path
          d="M918.175 144.999L922.186 150.657L914.361 153.284L904.292 144.165L900.014 133.585L898.831 133.802L896.474 136.25L895.7 139.097L878.021 146.1L878.056 146.12L876.913 146.535L876.549 146.677L876.54 146.67L864.681 150.982L866.714 165.198L877.916 161.226L892.417 155.942L899.305 152.82L902.882 158.045L906.312 159.405L907.881 162.081L914.799 159.606L923.358 152.204L922.219 146.593L918.175 144.999Z"
          fill="#0C6776"
        />
        <path
          d="M792.572 256.126L794.679 252.694L797.645 250.838L799.203 247.765L804.338 247.05L805.556 245.05L807.858 242.748L803.38 244.252L788.819 248.852L791.455 257.683L792.572 256.126Z"
          fill="#0C6776"
        />
        <path
          d="M870.516 252.219L869.549 251.282L858.372 255.324L847.628 229.07L834.001 233.939L820.064 238.593L809.396 242.216L814.497 242.228L817.749 244.788L819.72 246.83L822.178 246.741L824.957 247.621L825.557 247.815L825.471 248.37L825.153 250.293L828.464 250.409L831.818 251.543L832.85 250.013L836.87 252.081L835.143 255.101L835.44 256.941L833.263 259.935L833.248 259.945L833.106 262.512L833.009 264.449L834.689 264.707L837.392 262.632L839.633 265.623L850.262 268.08L844.063 251.066L844.162 242.616L845.488 242.366L851.653 257.637L862.742 264.13L863.214 263.009L863.332 262.71L863.34 262.709L863.594 262.589L867.055 261.006L870.516 252.219Z"
          fill="#0C6776"
        />
        <path
          d="M933.466 62.8648L918.775 55.7303L906.003 27.969L897.781 25.1379L889.953 32.8729L883.272 29.6996L879.512 48.9581L882.034 66.85L880.869 78.6781L876.501 84.6191L893.977 121.065L894.229 123.064L898.095 124.867L899.738 127.087L900.443 126.676L902.963 114.439L914.572 94.5491L926.602 83.3703L937.401 70.7659L933.466 62.8648Z"
          fill="#0C6776"
        />
        <path
          d="M582.108 142.11L584.082 145.841L597.929 147.182L607.407 149.324L611.586 148.49L615.174 148.085L616.833 151.635L620.675 152.239L623.058 155.53L623.059 155.538L622.432 157.726L622.473 160.531L626.012 159.978L626.013 159.986L625.585 164.269L627.515 165.845L633.351 150.296L643.514 145.866L654.473 138.627L667.572 137.964L679.14 133.127L669.944 126.776L670.988 124.741L667.601 125.137L667.21 127.532L661.508 127.853L656.942 122.636L643.152 127.898L630.595 136.014L617.878 129.882L608.125 128.821L610.265 117.394L600.038 126.169L589.36 135.705L580.849 141.972L582.108 142.11Z"
          fill="#0C6776"
        />
        <path
          d="M665.938 142.995L665.848 151.322L663.003 154.365L662.897 165.488L661.583 165.769L658.876 159.879L654.708 165.527L652.595 173.581L651.007 185.071L652.309 194.219L660.667 206.43L663.626 221.174L659.366 233.599L657.763 235.906L673.546 232.342L689.417 228.361L689.84 230.031L697.409 227.971L704.771 226.075L710.445 224.385L713.605 215.002L715.086 206.497L719.238 192.851L716.104 184.528L710.045 173.19L704.5 172.672L697.415 184.637L693.403 185.443L690.837 179.38L697.179 168.375L696.004 158.472L692.277 149.344L679.137 144.01L665.938 142.995Z"
          fill="#0C6776"
        />
        <path
          d="M468.83 105.979L470.591 109.102L470.795 111.976L470.599 114.834L471.261 119.131L471.941 123.044L474.078 126.852L476.484 131.399L477.748 135.841L478.351 138.521L478.757 141.59L480.088 147.916L480.76 149.093L481.533 154.237L482.769 158.585L484.444 161.995L485.857 165.396L486.252 168.84L486.316 168.832L486.334 169.577L486.411 170.209L486.355 170.216L486.45 173.193L483.186 176.133L482.767 178.758L484.473 181.628L487.527 183.1L491.993 204.482L494.129 224.606L511.063 222.558L532.884 219.282L556.306 215.566L576.567 212.553L575.959 210.832L575.009 205.637L574.335 204.241L568.516 201.937L563.775 198.755L562.277 196.591L560.422 195.493L554.994 193.272L553.002 193.385L547.248 189.554L546.947 184.28L546.003 178.272L546.3 172.778L542.281 169.053L544.058 164.045L550.706 158.086L548.553 145.883L552.381 143.979L551.912 140.926L560.778 129.588L570 118.695L582.447 109.544L565.004 107.422L553.429 112.463L537.701 107.883L522.091 106.675L511.403 106.8L505.89 103.412L501.716 91.7552L497.988 92.3476L499.091 101L468.545 104.634L468.83 105.979Z"
          fill="#0C6776"
        />
        <path
          d="M191.034 135.137L190.637 139.148L192.928 142.685L196.256 145.138L198.565 148.958L202.192 156.199L205.646 159.546L210.95 160.223L208.481 165.884L206.575 171.435L207.443 177.558L205.43 178.9L205.162 183.968L207.133 185.807L209.869 183.808L211.948 180.404L214.581 181.488L216.404 185.115L217.655 192.118L220.271 195.128L220.865 201.131L221.518 202.424L224.706 203.196L226.597 206.848L228.691 211.969L231.369 209.49L236.258 210.559L236.814 208.388L246.268 210.395L249.517 209.934L252.144 205.374L254.657 206.4L256.108 209.707L256.879 210.303L257.329 198.603L289.226 199.523L313.906 200.121L342.447 199.891L368.219 199.519L368.345 181.695L368.358 179.671L366.681 152.451L365.142 111.766L321.335 112.484L276.825 111.753L232.363 109.562L188.721 105.964L187.628 128.779L191.034 135.137Z"
          fill="#0C6776"
        />
        <path
          d="M852.515 302.23L834.566 308.478L800.437 319.24L774.655 325.987L771.688 326.763L771.941 328.909L773.159 332.374L769.621 334.462L767.906 338.975L764.63 339.415L759.065 345.535L757.145 344.039L754.229 347.367L754.762 348.942L751.649 351.782L750.419 354.157L746.687 357.251L742.807 359.332L739.547 360.769L737.888 363.748L737.23 366.541L733.967 368.758L734.548 372.26L746.899 369.115L755.816 366.85L757.306 365.816L765.911 359.456L782.388 354.987L791.455 353.492L791.88 354.643L792.89 353.204L797.466 356.569L798.042 358.626L817.224 353.032L843.236 366.834L848.632 363.798L860.111 348.17L874.264 334.296L879.579 315.271L870.071 295.956L852.515 302.23Z"
          fill="#0C6776"
        />
        <path
          d="M369.697 178.933L398.854 177.564L430.829 175.38L456.136 173.262L484.889 169.036L484.503 165.737L483.189 162.551L481.45 159.011L480.175 154.48L479.428 149.545L478.764 148.294L477.397 141.809L476.992 138.756L476.401 136.173L475.174 131.831L472.859 127.501L470.618 123.502L469.9 119.342L469.209 114.879L469.409 111.922L469.236 109.499L467.496 106.349L467.165 104.765L417.342 109.164L366.522 111.712L368.059 152.38L369.697 178.933Z"
          fill="#0C6776"
        />
        <path
          d="M496.465 250.177L495.665 248.48L493.133 248.496L491.278 247.398L490.368 245.731L485.83 244.408L481.498 242.118L475.912 242.929L472.205 243.226L470.828 244.458L464.114 243.14L459.812 240.83L427.304 243.493L402.785 245.019L371.524 246.385L372.712 279.861L373.06 289.442L406.672 287.969L407.86 310.246L437.029 308.356L459.175 306.558L498.306 302.585L520.584 299.87L518.414 296.456L515.52 294.031L512.081 290.739L511.474 288.823L509.831 284.865L509.813 280.791L509.005 277.162L506.544 271.095L505.26 268.823L503.835 268.185L503.057 262.806L501.659 259.46L498.082 255.567L497.9 253.608L496.465 250.177Z"
          fill="#0C6776"
        />
        <path
          d="M875.341 101.445L875.893 104.708L873.286 108.842L871.1 110.765L871.36 112.561L872.38 116.067L872.569 121.948L872.086 124.183L872.098 128.811L873.546 133.896L873.595 135.368L875.407 140.97L875.295 143.916L876.788 145.106L894.553 138.077L895.236 135.557L898.141 132.54L899.808 132.223L900.218 128.388L900.12 128.449L899.362 128.891L897.194 125.963L892.957 123.987L892.633 121.46L875.404 85.5038L871.847 87.5697L872.386 92.3278L872.402 92.3259L872.473 92.845L873.046 98.9473L875.341 101.445Z"
          fill="#0C6776"
        />
        <path
          d="M866.012 204.349L867.651 191.878L865.65 191.391L853.473 188.425L852.312 189.63L851.292 195.253L849.629 197.729L851.386 200.024L850.431 203.381L851.356 206.103L853.249 206.115L854.429 208.4L861.811 212.129L860.286 215.872L857.537 219.975L856.842 221.733L854.22 224.871L852.809 227.552L854.218 230.458L855.29 229.856L861.328 234.018L865.449 233.783L868.029 237.765L873.362 218.948L870.58 203.719L866.012 204.349Z"
          fill="#0C6776"
        />
        <path
          d="M328.909 490.783L346.829 490.621L381.129 489.795L398.102 489.131L393.705 389.616L393.573 386.798L393.221 379.248L372.563 379.995L342.236 380.637L314.038 380.679L286.803 380.304L286.805 380.32L286.797 380.321L284.045 505.135L298.095 505.339L298.457 496.118L330.826 496.242L329.229 493.602L328.909 490.783Z"
          fill="#0C6776"
        />
        <path
          d="M196.686 374.611L196.694 374.61L196.719 374.217L205.097 265.106L156.871 260.418L156.865 260.435L156.856 260.493L156.229 260.415L133.254 257.546L107.929 254.38L98.5642 319.408L127.123 353.301L155.621 386.096L182.56 416.174L183.615 413.163L183.093 408.817L183.085 404.489L183.476 399.829L182.055 396.502L183.901 393.191L188.273 393.551L191.732 395.477L193.433 396.236L194.674 393.429L195.406 392.836L196.592 375.979L196.584 375.98L196.638 375.291L196.686 374.611Z"
          fill="#0C6776"
        />
        <path
          d="M872.645 189.861L872.12 190.356L869.853 186.945L872.343 183.791L870.841 182.788L865.727 167.015L865.594 167.056L865.484 166.29L865.299 165.703L865.4 165.667L863.25 150.694L857.463 133.995L855.436 134.616L854.404 133.418L854.198 129.992L850.7 125.075L850.535 120.189L848.535 117.38L845.723 111.161L845.284 108.291L844.172 104.699L822.534 113.061L817.371 119.204L807.188 138.604L809.771 141.002L813.813 149.385L804.284 160.885L790.808 163.461L778.566 166.626L772.002 171.405L775.746 176.406L775.778 176.532L776.859 178.739L767.306 195.707L768.804 200.536L792.826 192.873L815.743 185.135L837.274 177.549L842.117 179.703L845.012 181.072L845.471 183.704L847.321 186.021L850.264 186.45L853.01 186.927L853.031 186.9L853.391 186.986L854.644 187.207L854.572 187.281L868.725 190.729L868.993 190.794L869.169 190.838L869.099 191.333L870.458 197.754L879.668 194.163L898.091 180.069L893.404 178.529L872.645 189.861Z"
          fill="#0C6776"
        />
        <path
          d="M711.003 225.672L705.142 227.418L697.764 229.324L690.18 231.394L694.83 250.293L703.416 285.693L708.848 284.82L712.648 286.274L718.256 289.91L722.195 290.511L724.993 291.485L728.783 289.862L732.011 290.297L735.211 288.226L738.765 286.802L741.12 289.674L744.392 290.729L747.914 289.244L749.101 286.127L748.05 281.366L749.238 275.39L752.678 275.223L753.359 277.016L753.648 276.721L753.582 274.78L753.141 270.562L756.09 265.305L758.431 265.19L760.276 264.072L761.748 262.618L764.659 256.724L764.303 254.6L764.536 249.447L764.572 243.482L763.895 238.529L762.174 235.661L764.2 233.83L756.076 206.617L749.567 211.316L741.767 220.015L730.7 226.293L722.117 227.436L711.003 225.672Z"
          fill="#0C6776"
        />
        <path
          d="M765.628 233.776L771.331 252.782L787.771 247.742L802.956 242.935L808.106 241.219L819.639 237.296L833.56 232.643L847.467 227.676L848.05 225.794L849.429 223.985L853.314 223.812L855.653 221.01L856.358 219.267L859.106 215.164L860.067 212.781L853.412 209.418L852.412 207.477L850.371 207.458L848.993 203.411L849.872 200.299L847.94 197.774L849.995 194.713L851.041 188.966L851.856 188.12L850.055 187.803L846.591 187.299L844.185 184.287L843.785 182.005L841.554 180.954L837.217 179.021L816.193 186.432L793.263 194.18L767.91 202.256L767.109 199.682L766.252 196.912L757.243 205.684L764.849 231.183L765.628 233.776Z"
          fill="#0C6776"
        />
        <path
          d="M901.982 159.176L898.812 154.551L893.563 156.929L898.075 167.635L898.252 169.822L906.683 162.769L905.361 160.518L901.982 159.176Z"
          fill="#0C6776"
        />
        <path
          d="M804.67 410.825L807.865 414.585L808.947 418.4L810.396 418.629L813.501 418.787L828.949 402.473L840.383 384.545L842.508 367.996L817.084 354.503L797.086 360.335L796.28 357.387L793.213 355.146L791.519 357.57L790.569 355.038L782.648 356.345L766.524 360.713L758.113 366.928L756.616 367.971L755.267 370.101L753.767 374.247L758.827 376.253L762.444 376.746L767.791 382.843L770.85 385.946L778.53 389.322L780.51 391.647L785.776 393.945L789.313 398.444L796.375 401.148L799.17 405.826L801.084 408.07L800.944 409.581L804.67 410.825Z"
          fill="#0C6776"
        />
        <path
          d="M485.038 172.61L484.974 170.425L456.285 174.644L430.923 176.769L398.933 178.962L369.724 180.321L369.673 188.359L369.589 200.202L371.07 235.811L371.455 245.03L402.7 243.667L427.194 242.143L460.088 239.45L464.658 241.898L470.404 243L471.62 241.918L475.745 241.578L481.723 240.719L486.392 243.179L491.281 244.581L492.286 246.432L493.493 247.138L495.327 247.126L495.217 246.156L492.167 243.921L493.159 239.732L493.588 236.122L493.678 234L491.3 231.342L490.605 225.043L492.75 224.782L490.62 204.707L486.301 184.061L483.486 182.69L481.312 179.041L481.889 175.446L485.038 172.61Z"
          fill="#0C6776"
        />
        <path
          d="M847.071 110.858L849.762 116.75L851.903 119.722L852.061 124.616L855.549 129.518L855.755 132.871L855.897 133.033L858.324 132.29L864.345 149.642L875.287 145.669L873.891 144.548L874.031 141.161L872.233 135.606L872.181 134.11L870.729 129L870.732 123.956L871.209 121.738L871.016 116.288L870.014 112.804L869.642 110.218L872.305 107.88L874.45 104.419L874.058 102.071L871.727 99.5367L871.199 93.8677L845.464 104.199L846.637 108.028L847.071 110.858Z"
          fill="#0C6776"
        />
        <path
          d="M67.9406 149.494L71.3678 152.227L75.7539 154.364L78.0489 159.469L77.796 163.325L78.3222 166.176L81.3449 167.456L84.9598 167.998L91.2792 166.676L95.0944 166.527L100.766 168.484L102.829 169.889L105.877 169.639L109.78 168.351L116.757 169.694L122.673 168.12L126.164 166.647L130.03 168.19L135.811 166.641L167.317 170.289L167.763 167.148L166.722 163.604L169.736 132.296L172.757 104.308L129.562 98.7797L86.8584 91.8269L90.4764 110.519L89.7412 129.474L83.913 135.893L80.1295 116.376L61.3522 108.968L59.8005 129.752L60.4295 148.24L63.1305 148.48L67.9406 149.494Z"
          fill="#0C6776"
        />
        <path
          d="M553.366 191.996L555.205 191.893L561.06 194.29L563.213 195.563L564.74 197.764L569.207 200.76L575.322 203.158L576.322 205.302L577.285 210.536L578.509 213.919L581.458 217.32L580.197 219.439L580.999 223.686L581.95 225.43L583.473 228.46L589.07 229.605L591.156 232.526L607.257 229.508L624.141 226.175L635.874 223.901L635.86 223.846L636.019 223.818L635.4 219.143L631.083 208.844L631.09 208.697L631.447 195.7L631.715 179.58L635.797 162.093L634.891 162.325L626.314 179.377L622.562 176.375L626.956 167.182L624.133 164.879L624.131 164.863L624.459 161.623L621.12 162.144L621.119 162.136L621.074 157.439L621.54 155.799L619.891 153.523L615.883 152.89L614.334 149.579L611.787 149.865L607.56 150.697L607.378 150.735L607.127 150.677L597.648 148.535L583.203 147.152L581.228 143.406L579.22 143.188L579.19 143.207L578.305 143.876L577.756 143.569L567.54 137.911L553.871 144.758L553.872 144.774L550.066 146.659L552.293 159.268L551.301 159.389L545.217 164.841L543.864 168.668L547.683 172.214L547.365 178.206L548.291 184.135L548.566 188.795L553.366 191.996Z"
          fill="#0C6776"
        />
        <path
          d="M745.343 291.82L745.973 293.254L746.966 297.542L749.89 300.345L751.523 303.216L754.723 305.278L756.912 307.18L759.694 306.751L760.174 305.962L760.522 306.618L761.486 306.468L760.925 307.389L762.43 310.276L764.662 311.53L767.313 312.36L771.973 308.219L774.531 309.15L779.714 305.903L779.479 303.504L779.495 303.502L779.492 303.478L782.077 303.699L783.656 301.598L786.147 301.18L787.963 299.148L787.789 297.521L786.814 295.252L786.7 294.99L786.699 294.982L786.706 294.965L788.015 290.184L790.298 286.593L790.171 283.286L791.882 278.595L792.076 272.659L795.681 273.917L798.259 274.553L799.884 273.356L800.064 271.369L801.932 263.906L803.533 264.45L804.893 261.417L807.239 257.607L808.481 255.076L807.872 248.215L818.318 251.23L818.719 247.786L818.031 247.074L816.795 245.796L814.028 243.615L808.952 243.609L806.584 245.968L805.183 248.332L800.103 249.032L798.695 251.802L795.685 253.696L793.711 256.892L790.935 260.763L787.512 249.267L770.406 254.511L764.636 235.285L763.934 235.923L765.217 238.057L765.948 243.384L765.911 249.48L765.68 254.51L766.081 256.938L762.876 263.428L761.055 265.209L758.846 266.542L756.909 266.64L754.548 270.85L754.95 274.683L755.045 277.262L752.833 279.505L751.746 276.649L750.373 276.711L749.452 281.347L750.526 286.226L748.989 290.279L745.343 291.82Z"
          fill="#0C6776"
        />
        <path
          d="M255.962 268.033L254.989 288.299L287.984 289.963L304.868 290.236L321.739 290.332L355.493 289.954L371.672 289.501L371.309 279.394L370.109 245.757L368.247 200.895L342.459 201.268L313.893 201.501L289.189 200.906L258.643 200.025L258.23 210.827L258.059 211.23L258.48 211.552L256.027 266.651L255.996 267.264L255.962 268.033Z"
          fill="#0C6776"
        />
        <path
          d="M577.361 521.936L579.093 517.884L581.39 514.745L580.867 510.854L579.136 509.506L580.126 503.441L580.966 500.935L581.578 492.901L579.554 490.281L576.576 485.504L572.737 477.526L569.192 475.424L564.706 452.274L564.61 452.286L564.565 451.585L564.443 450.918L564.531 450.907L563.881 439.576L560.312 440.011L556.446 440.88L555.105 439.403L546.733 436.209L541.564 434.646L537.696 436.62L531.044 437.219L527.407 437.695L524.471 439.856L521.27 441.245L518.39 440.467L512.134 442.448L509.191 439.355L506.891 442.542L501.065 441.514L495.843 438.781L490.247 441.704L487.201 436.439L479.026 437.728L473.322 437.034L466.684 435.943L463.7 431.783L459.201 433.582L455.777 431.872L450.856 429.678L447.551 387.031L430.314 388.263L412.37 389.362L395.104 390.223L399.541 490.466L381.178 491.185L346.852 492.006L330.45 492.154L330.556 493.164L332.608 496.536L339.558 504.321L349.422 511.224L361.233 520.983L368.066 532.73L373.186 544.759L383.329 551.083L399.397 556.986L410.867 538.826L427.408 537.476L442.113 545.721L453.169 560.543L461.011 573.182L473.911 585.139L479.707 600.642L486.146 610.504L502.487 615.976L517.308 619.44L524.084 618.135L519.853 611.602L517.656 600.711L517.652 600.671L516.176 584.966L519.772 574.093L529.683 561.922L548.087 549.942L563.799 531.005L579.106 524.267L577.361 521.936Z"
          fill="#0C6776"
        />
        <path
          d="M260.298 377.981L285.455 378.903L287.269 291.3L253.562 289.593L254.594 267.94L250.448 267.706L206.459 265.198L199.625 354.25L198.054 374.679L226.079 376.266L260.298 377.981Z"
          fill="#0C6776"
        />
        <path
          d="M430.216 386.878L448.805 385.546L452.153 428.74L456.353 430.616L459.25 432.066L464.183 430.092L467.46 434.663L473.51 435.655L478.992 436.327L487.909 434.924L490.768 439.862L495.829 437.215L501.59 440.232L506.268 441.035L509.031 437.19L512.523 440.857L518.35 439.018L521.154 439.773L523.838 438.609L526.862 436.365L530.882 435.834L537.292 435.256L541.421 433.153L547.164 434.897L554.692 437.756L552.66 419.488L550.062 398.04L543.468 375.846L543.356 375.86L543.287 375.226L543.07 374.514L543.198 374.498L543.03 373.057L542.16 365.716L527.257 367.711L495.371 371.491L463.395 374.65L445.604 376.136L427.82 377.41L411.732 378.404L411.733 378.42L411.03 378.449L410.353 378.491L410.36 378.482L398.472 379.021L394.587 379.194L394.797 383.846L395.031 388.837L412.281 387.977L430.216 386.878Z"
          fill="#0C6776"
        />
        <path
          d="M107.45 252.931L155.709 258.963L160.282 219.726L160.298 219.659L160.297 219.651L162.327 213.719L161.491 211.125L158.52 209.197L159.025 205.083L161.991 200.028L165.799 196.096L168.776 189.269L171.566 183.642L173.298 181.124L172.89 178.177L170.545 176.132L167.512 171.702L135.915 168.041L129.946 169.646L126.182 168.147L123.068 169.445L116.806 171.109L109.863 169.779L106.155 171.002L102.456 171.307L100.065 169.682L94.8892 167.925L91.4451 168.052L84.9995 169.406L80.885 168.763L77.1082 167.16L76.4168 163.42L76.6492 159.729L74.7077 155.393L70.5694 153.356L67.3398 150.777L62.8901 149.849L60.2702 149.608L51.3632 181.741L45.502 206.347L36.1641 228.681L38.879 241.295L107.45 252.931Z"
          fill="#0C6776"
        />
        <path
          d="M409.931 345.13L411.659 377.038L427.732 376.045L445.507 374.764L463.273 373.281L495.228 370.134L527.09 366.356L541.913 364.371L538.888 341.488L535.892 318.303L531.278 316.892L528.435 312.357L526.623 310.15L528.537 305.596L527.864 303.275L526.022 303.556L521.602 301.139L498.443 303.961L459.289 307.929L437.113 309.738L407.929 311.622L409.931 345.13Z"
          fill="#0C6776"
        />
        <path
          d="M669.482 421.812L666.774 392.989L664.906 389.594L645.602 393.051L628.448 396.368L628.429 397.946L625.569 400.13L626.045 403.036L624.624 409.698L622.625 411.428L620.083 414.824L618.994 419.545L616.383 427.838L616.853 432.832L620.008 438.262L619.89 442.556L621.551 443.661L620.391 447.27L623.824 451.245L623.537 454.09L626.823 457.661L624.395 460.661L624.268 464.956L621.205 469.074L620.34 473.832L619.529 479.575L617.734 482.303L619.17 486.822L635.487 484.639L654.137 481.205L654.325 485.884L653.796 489.473L655.318 491.699L658.378 493.819L659.846 497.53L660.439 499.131L670.789 497.431L680.966 490.449L673.509 457.446L669.482 421.812Z"
          fill="#0C6776"
        />
        <path
          d="M744.649 293.629L743.926 292.02L740.307 290.853L738.341 288.446L735.786 289.472L732.332 291.72L728.971 291.261L725.043 292.949L721.804 291.825L717.758 291.214L711.966 287.462L708.705 286.227L703.337 287.092L702.99 287.711L705.379 291.659L704.925 294.126L701.879 294.92L699.648 297.539L695.917 297.709L696.495 301.521L694.371 303.818L692.979 308.186L690.727 309.435L688.376 317.128L683.582 315.844L682.49 314.28L680.967 318.104L679.327 321.577L674.836 319.777L671.812 322.346L670.806 325.222L664.533 322.998L661.422 326.122L657.185 325.477L657.511 327.817L655.292 327.73L655.548 328.633L654.316 331.852L656.471 333.807L653.142 336.543L649.978 338.902L651.6 343.415L649.151 346.312L644.175 345.067L639.885 344.851L639.368 346.465L640.532 349.222L640.675 349.327L640.668 349.538L641.571 351.686L640.591 350.969L640.546 351.868L641.656 355.517L638.927 358.18L637.314 359.603L659.302 355.307L658.523 351.918L663.059 350.886L663.829 351.742L674.238 348.858L693.988 344.656L704.127 342.892L709.103 341.401L724.627 338.51L736.095 334.79L740.695 332.288L743.7 330.152L743.872 329.7L744.658 327.688L748.698 323.85L749.403 322.245L749.783 321.362L749.723 319.339L749.73 319.33L754.555 315.202L754.941 314.57L758.762 308.281L756.491 308.639L753.857 306.345L750.5 304.188L748.744 301.113L745.724 298.249L744.649 293.629Z"
          fill="#0C6776"
        />
        <path
          d="M634.281 360.199L634.646 360.13L637.998 357.179L640.103 355.128L639.168 352.05L639.267 350L636.137 347.709L634.199 348.733L630.453 343.115L630.455 339.664L628.348 335.105L626.674 334.83L621.314 330.967L619.368 331.253L615.041 328.605L611.737 325.549L612.194 321.034L613.168 317.635L613.367 313.867L610.142 311.466L607.306 313.379L604.51 312.632L603.481 308.721L601.466 305.109L599.944 304.482L595.33 302.137L591.363 298.91L587.696 294.809L584.946 288.241L585.447 282.82L583.139 281.542L579.58 278.727L561.674 282.128L542.38 285.21L527.324 287.346L513.027 289.177L513.278 289.967L513.29 290.006L516.436 293.025L519.523 295.638L522.238 299.92L526.293 302.138L528.859 301.744L530.014 305.688L528.225 309.934L529.59 311.603L532.181 315.738L537.158 317.259L540.268 341.316L543.286 364.208L543.382 364.196L544.576 374.332L565.54 371.631L585.141 368.608L603.817 365.455L624.604 363.092L627.123 366.172L623.826 371.974L623.472 373.195L633.434 371.315L633.751 366.249L634.221 362.911L634.249 361.608L632.591 361.932L634.279 360.451L634.281 360.199Z"
          fill="#0C6776"
        />
        <path
          d="M758.898 343.681L763.948 338.136L766.905 337.743L768.496 333.545L771.481 331.785L770.578 329.166L770.345 327.189L762.52 329.823L737.214 335.937L736.55 336.091L724.909 339.856L709.386 342.755L704.395 344.249L694.239 346.014L674.552 350.2L663.358 353.302L662.568 352.416L660.165 352.961L660.95 356.398L635.612 361.337L635.571 363.064L635.1 366.394L634.761 371.876L634.934 373.829L633.624 377.537L630.997 380.172L630.997 383.843L628.75 387.186L630.171 393.518L629.28 394.804L645.347 391.701L665.144 388.151L687.645 383.273L710.644 378.221L724.406 375.065L733.205 372.629L732.463 368.139L736.009 365.717L736.634 363.18L738.566 359.713L742.205 358.116L745.97 356.09L749.325 353.301L750.541 350.952L753.171 348.545L752.675 347.07L756.958 342.171L758.898 343.681Z"
          fill="#0C6776"
        />
        <path
          d="M778.305 323.624L800.065 317.918L834.154 307.177L852.064 300.934L869.271 294.793L859.991 283.685L853.325 274.899L838.99 266.893L838.84 266.862L838.772 266.773L838.714 266.691L837.126 264.594L835.062 266.177L832.172 265.726L831.569 265.637L831.568 265.629L831.709 262.988L831.899 259.481L833.985 256.612L833.747 255.123L833.482 254.148L831.783 252.999L828.107 251.758L823.529 251.641L824.009 248.781L821.975 248.152L820.049 248.208L819.505 253.009L809.422 250.104L809.89 255.342L808.445 258.279L806.093 262.106L804.281 266.16L802.916 265.693L801.411 271.667L801.217 273.94L801.204 274.096L800.965 274.271L798.558 276.043L798.55 276.044L795.343 275.249L795.284 275.232L793.384 274.57L793.241 278.859L791.549 283.499L791.688 286.975L791.552 287.186L789.235 290.831L788.152 294.877L789.14 297.12L789.409 299.588L789.387 299.607L789.39 299.631L786.84 302.5L784.412 302.901L782.707 305.172L781.016 305.021L781.169 306.61L781.161 306.611L781.165 306.643L774.683 310.698L772.261 309.815L767.63 313.929L764.055 312.781L761.389 311.295L760.074 308.767L757.106 313.603L755.527 316.175L755.528 316.183L755.52 316.184L751.115 319.953L751.173 321.627L750.671 322.768L749.838 324.664L745.823 328.5L745.189 330.095L744.824 331.033L744.817 331.042L741.372 333.492L741.318 333.523L762.139 328.501L770.189 325.79L770.184 325.75L770.743 325.609L771.515 325.344L771.522 325.4L778.305 323.624Z"
          fill="#0C6776"
        />
        <path
          d="M864.393 263.735L863.753 265.283L863.125 280.716L863.671 280.804L866.7 262.674L864.393 263.735Z"
          fill="#0C6776"
        />
        <path
          d="M734.169 373.783L724.749 376.385L711.745 379.367L722.582 404.383L732.12 424.806L736.387 430.897L739.188 434.689L736.992 439.456L737.631 446.305L739.633 450.138L740.132 454.227L740.487 457.74L742.234 460.078L743.793 462.413L747.807 467.227L766.549 463.489L798.266 458.454L800.397 461.41L801.528 459.835L799.407 452.159L802.072 450.365L806.371 450.929L809.749 450.322L809.724 437.454L812.958 420.144L810.211 419.999L807.869 419.635L806.628 415.255L803.871 412.017L799.468 410.54L799.661 408.527L798.02 406.591L795.439 402.268L788.471 399.601L784.906 395.074L779.674 392.788L777.692 390.455L770.056 387.106L766.785 383.785L761.749 378.048L758.402 377.571L752.018 375.035L754.065 369.442L754.603 368.589L747.608 370.367L734.169 373.783Z"
          fill="#0C6776"
        />
        <path
          d="M845.063 503.947L842.538 495.557L829.244 481.966L816.808 466.217L810.041 451.669L806.41 452.33L802.415 451.802L801.004 452.754L803.029 460.108L800.414 463.773L797.65 459.951L766.802 464.848L747.283 468.745L742.994 463.6L705.083 472.654L695.123 476.093L695.153 476.999L700.643 481.405L700.572 486.417L700.112 488.503L720.005 481.279L740.636 486.975L746.198 491.762L765.14 477.337L778.562 482.986L794.544 492.781L802.486 504.035L802.815 518.264L807.342 528.018L821.23 541.227L836.873 556.968L845.924 559.86L851.783 568.421L861.744 568.197L868.489 562.234L866.87 542.552L860.191 523.599L845.063 503.947Z"
          fill="#0C6776"
        />
        <path
          d="M533.074 220.643L511.24 223.929L492.128 226.234L492.622 230.754L495.075 233.492L494.961 236.227L494.504 240.002L493.718 243.346L496.527 245.408L496.764 247.62L497.709 249.641L499.232 253.28L499.392 254.99L502.819 258.722L504.388 262.535L505.069 267.252L506.22 267.769L507.793 270.55L510.32 276.82L511.177 280.654L511.187 284.599L512.542 287.853L527.118 285.979L542.167 283.853L561.42 280.776L579.921 277.254L583.93 280.428L585.358 281.212L585.088 278.135L588.855 274.062L589.378 270.62L590.79 266.679L589.669 263.876L587.085 262.404L588.073 257.517L593.845 255.303L597.125 253.49L597.842 251.916L599.887 246.567L599.685 240.98L597.963 239.647L594.942 238.31L593.748 236.109L591.692 235.368L590.579 234.034L590.548 234.046L590.303 233.702L589.571 232.825L589.666 232.805L588.266 230.84L582.544 229.67L580.733 226.074L579.673 224.043L578.756 219.184L579.774 217.469L577.317 214.633L577.03 213.881L556.497 216.927L533.074 220.643Z"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter0_d_268_1373)">
        <path
          d="M145.725 108.336C141.855 108.525 138.026 107.393 134.921 105.047C130.431 101.653 123.913 101.399 119.07 104.43L116.722 105.898C116.307 106.16 115.783 106.179 115.349 105.951C114.914 105.725 114.633 105.284 114.609 104.795L113.493 81.9645C113.469 81.4642 113.717 80.9917 114.14 80.7265L116.488 79.2564C122.373 75.571 129.999 75.8764 135.471 80.0118C139.023 82.6954 143.941 83.4714 148.303 82.0328C148.712 81.8953 149.161 81.9612 149.518 82.2061C149.872 82.451 150.094 82.8466 150.115 83.2782L151.231 106.107C151.262 106.729 150.874 107.292 150.283 107.487C148.786 107.979 147.252 108.26 145.724 108.336L145.725 108.336Z"
          fill="#FEC077"
        />
        <ellipse
          cx="116.57"
          cy="135.099"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 116.57 135.099)"
          fill="#BADED9"
        />
        <ellipse
          cx="116.571"
          cy="135.098"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 116.571 135.098)"
          fill="#0C6776"
        />
        <rect
          x="112.18"
          y="73.3391"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 112.18 73.3391)"
          fill="#0C6776"
        />
        <circle
          cx="113.634"
          cy="73.5563"
          r="4.47008"
          transform="rotate(-2.79885 113.634 73.5563)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter1_d_268_1373)">
        <path
          d="M98.8919 189.552C95.0228 189.742 91.1928 188.609 88.0886 186.264C83.598 182.869 77.0803 182.615 72.2372 185.646L69.8897 187.114C69.4741 187.377 68.9505 187.395 68.5162 187.168C68.0815 186.942 67.8 186.5 67.7761 186.011L66.6606 163.181C66.6361 162.681 66.8842 162.208 67.3074 161.943L69.6554 160.473C75.5403 156.788 83.166 157.093 88.6383 161.228C92.1904 163.912 97.1078 164.688 101.47 163.249C101.879 163.112 102.329 163.178 102.685 163.423C103.04 163.668 103.261 164.063 103.283 164.495L104.399 187.324C104.429 187.945 104.041 188.508 103.451 188.703C101.953 189.196 100.419 189.476 98.8911 189.552L98.8919 189.552Z"
          fill="#FEC077"
        />
        <ellipse
          cx="69.7377"
          cy="216.315"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 69.7377 216.315)"
          fill="#BADED9"
        />
        <ellipse
          cx="69.7379"
          cy="216.315"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 69.7379 216.315)"
          fill="#0C6776"
        />
        <rect
          x="65.3468"
          y="154.556"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 65.3468 154.556)"
          fill="#0C6776"
        />
        <circle
          cx="66.8014"
          cy="154.773"
          r="4.47008"
          transform="rotate(-2.79885 66.8014 154.773)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter2_d_268_1373)">
        <path
          d="M89.6321 297.054C85.763 297.243 81.933 296.111 78.8288 293.766C74.3382 290.371 67.8204 290.117 62.9774 293.148L60.6299 294.616C60.2143 294.879 59.6906 294.897 59.2564 294.67C58.8217 294.443 58.5402 294.002 58.5163 293.513L57.4008 270.683C57.3763 270.183 57.6244 269.71 58.0475 269.445L60.3956 267.975C66.2805 264.289 73.9061 264.595 79.3784 268.73C82.9306 271.414 87.848 272.19 92.2102 270.751C92.6194 270.614 93.0689 270.679 93.425 270.924C93.7799 271.169 94.0016 271.565 94.0227 271.996L95.1388 294.825C95.1692 295.447 94.7813 296.01 94.1909 296.205C92.6935 296.698 91.1591 296.978 89.6313 297.054L89.6321 297.054Z"
          fill="#FEC077"
        />
        <ellipse
          cx="60.4778"
          cy="323.816"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 60.4778 323.816)"
          fill="#BADED9"
        />
        <ellipse
          cx="60.478"
          cy="323.815"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 60.478 323.815)"
          fill="#0C6776"
        />
        <rect
          x="56.0869"
          y="262.057"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 56.0869 262.057)"
          fill="#0C6776"
        />
        <circle
          cx="57.5415"
          cy="262.274"
          r="4.47008"
          transform="rotate(-2.79885 57.5415 262.274)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter3_d_268_1373)">
        <path
          d="M173.217 410.904C169.348 411.093 165.518 409.961 162.413 407.616C157.923 404.221 151.405 403.967 146.562 406.998L144.215 408.466C143.799 408.729 143.275 408.747 142.841 408.52C142.406 408.294 142.125 407.852 142.101 407.363L140.985 384.533C140.961 384.033 141.209 383.56 141.632 383.295L143.98 381.825C149.865 378.139 157.491 378.445 162.963 382.58C166.515 385.264 171.433 386.04 175.795 384.601C176.204 384.464 176.654 384.53 177.01 384.774C177.365 385.019 177.586 385.415 177.607 385.847L178.723 408.675C178.754 409.297 178.366 409.86 177.776 410.055C176.278 410.548 174.744 410.828 173.216 410.904L173.217 410.904Z"
          fill="#FEC077"
        />
        <ellipse
          cx="144.062"
          cy="437.666"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 144.062 437.666)"
          fill="#BADED9"
        />
        <ellipse
          cx="144.063"
          cy="437.666"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 144.063 437.666)"
          fill="#0C6776"
        />
        <rect
          x="139.671"
          y="375.907"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 139.671 375.907)"
          fill="#0C6776"
        />
        <circle
          cx="141.126"
          cy="376.124"
          r="4.47008"
          transform="rotate(-2.79885 141.126 376.124)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter4_d_268_1373)">
        <path
          d="M652.891 220.529C649.022 220.718 645.192 219.586 642.088 217.24C637.597 213.846 631.079 213.592 626.236 216.623L623.889 218.091C623.473 218.353 622.95 218.372 622.515 218.145C622.081 217.918 621.799 217.477 621.775 216.988L620.66 194.158C620.635 193.657 620.883 193.185 621.307 192.92L623.655 191.45C629.54 187.764 637.165 188.07 642.637 192.205C646.19 194.888 651.107 195.665 655.469 194.226C655.878 194.088 656.328 194.154 656.684 194.399C657.039 194.644 657.261 195.04 657.282 195.471L658.398 218.3C658.428 218.922 658.04 219.485 657.45 219.68C655.953 220.173 654.418 220.453 652.89 220.529L652.891 220.529Z"
          fill="#FEC077"
        />
        <ellipse
          cx="623.737"
          cy="247.291"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 623.737 247.291)"
          fill="#BADED9"
        />
        <ellipse
          cx="623.738"
          cy="247.291"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 623.738 247.291)"
          fill="#0C6776"
        />
        <rect
          x="619.347"
          y="185.532"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 619.347 185.532)"
          fill="#0C6776"
        />
        <circle
          cx="620.801"
          cy="185.749"
          r="4.47008"
          transform="rotate(-2.79885 620.801 185.749)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter5_d_268_1373)">
        <path
          d="M400.53 298.001C396.661 298.19 392.831 297.057 389.727 294.712C385.237 291.317 378.719 291.063 373.876 294.094L371.528 295.563C371.113 295.825 370.589 295.844 370.155 295.616C369.72 295.39 369.439 294.949 369.415 294.46L368.299 271.629C368.275 271.129 368.523 270.656 368.946 270.391L371.294 268.921C377.179 265.236 384.804 265.541 390.277 269.677C393.829 272.36 398.746 273.136 403.109 271.698C403.518 271.56 403.967 271.626 404.323 271.871C404.678 272.116 404.9 272.511 404.921 272.943L406.037 295.772C406.068 296.393 405.68 296.956 405.089 297.151C403.592 297.644 402.057 297.925 400.53 298L400.53 298.001Z"
          fill="#FEC077"
        />
        <ellipse
          cx="371.376"
          cy="324.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 371.376 324.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="371.376"
          cy="324.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 371.376 324.762)"
          fill="#0C6776"
        />
        <rect
          x="366.985"
          y="263.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 366.985 263.003)"
          fill="#0C6776"
        />
        <circle
          cx="368.44"
          cy="263.221"
          r="4.47008"
          transform="rotate(-2.79885 368.44 263.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter6_d_268_1373)">
        <path
          d="M273.19 396.038C269.321 396.227 265.491 395.094 262.387 392.749C257.896 389.354 251.378 389.1 246.535 392.131L244.188 393.6C243.772 393.862 243.248 393.88 242.814 393.653C242.38 393.427 242.098 392.985 242.074 392.497L240.959 369.666C240.934 369.166 241.182 368.693 241.605 368.428L243.953 366.958C249.838 363.273 257.464 363.578 262.936 367.713C266.488 370.397 271.406 371.173 275.768 369.735C276.177 369.597 276.627 369.663 276.983 369.908C277.338 370.153 277.559 370.548 277.581 370.98L278.697 393.809C278.727 394.43 278.339 394.993 277.749 395.188C276.251 395.681 274.717 395.961 273.189 396.037L273.19 396.038Z"
          fill="#FEC077"
        />
        <ellipse
          cx="244.036"
          cy="422.8"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 244.036 422.8)"
          fill="#BADED9"
        />
        <ellipse
          cx="244.036"
          cy="422.799"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 244.036 422.799)"
          fill="#0C6776"
        />
        <rect
          x="239.645"
          y="361.041"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 239.645 361.041)"
          fill="#0C6776"
        />
        <circle
          cx="241.1"
          cy="361.258"
          r="4.47008"
          transform="rotate(-2.79885 241.1 361.258)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter7_d_268_1373)">
        <path
          d="M472.347 424.403C468.478 424.592 464.648 423.46 461.544 421.115C457.053 417.72 450.536 417.466 445.692 420.497L443.345 421.965C442.929 422.228 442.406 422.246 441.971 422.019C441.537 421.793 441.255 421.351 441.231 420.862L440.116 398.032C440.091 397.532 440.339 397.059 440.763 396.794L443.111 395.324C448.996 391.638 456.621 391.944 462.094 396.079C465.646 398.763 470.563 399.539 474.925 398.1C475.334 397.963 475.784 398.029 476.14 398.273C476.495 398.518 476.717 398.914 476.738 399.346L477.854 422.174C477.884 422.796 477.496 423.359 476.906 423.554C475.409 424.047 473.874 424.327 472.346 424.403L472.347 424.403Z"
          fill="#FEC077"
        />
        <ellipse
          cx="443.193"
          cy="451.166"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 443.193 451.166)"
          fill="#BADED9"
        />
        <ellipse
          cx="443.193"
          cy="451.165"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 443.193 451.165)"
          fill="#0C6776"
        />
        <rect
          x="438.802"
          y="389.406"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 438.802 389.406)"
          fill="#0C6776"
        />
        <circle
          cx="440.257"
          cy="389.623"
          r="4.47008"
          transform="rotate(-2.79885 440.257 389.623)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter8_d_268_1373)">
        <path
          d="M508.53 320C504.661 320.19 500.831 319.057 497.727 316.712C493.236 313.317 486.719 313.063 481.876 316.094L479.528 317.562C479.112 317.825 478.589 317.843 478.155 317.616C477.72 317.39 477.438 316.948 477.414 316.459L476.299 293.629C476.274 293.129 476.523 292.656 476.946 292.391L479.294 290.921C485.179 287.236 492.804 287.541 498.277 291.676C501.829 294.36 506.746 295.136 511.108 293.697C511.518 293.56 511.967 293.626 512.323 293.871C512.678 294.116 512.9 294.511 512.921 294.943L514.037 317.772C514.067 318.393 513.679 318.956 513.089 319.151C511.592 319.644 510.057 319.924 508.529 320L508.53 320Z"
          fill="#FEC077"
        />
        <ellipse
          cx="479.376"
          cy="346.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 479.376 346.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="479.376"
          cy="346.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 479.376 346.762)"
          fill="#0C6776"
        />
        <rect
          x="474.985"
          y="285.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 474.985 285.003)"
          fill="#0C6776"
        />
        <circle
          cx="476.44"
          cy="285.221"
          r="4.47008"
          transform="rotate(-2.79885 476.44 285.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter9_d_268_1373)">
        <path
          d="M602.53 137C598.661 137.19 594.831 136.057 591.727 133.712C587.236 130.317 580.719 130.063 575.876 133.094L573.528 134.562C573.112 134.825 572.589 134.843 572.155 134.616C571.72 134.39 571.438 133.948 571.414 133.459L570.299 110.629C570.274 110.129 570.523 109.656 570.946 109.391L573.294 107.921C579.179 104.236 586.804 104.541 592.277 108.676C595.829 111.36 600.746 112.136 605.108 110.697C605.518 110.56 605.967 110.626 606.323 110.871C606.678 111.116 606.9 111.511 606.921 111.943L608.037 134.772C608.067 135.393 607.679 135.956 607.089 136.151C605.592 136.644 604.057 136.924 602.529 137L602.53 137Z"
          fill="#FEC077"
        />
        <ellipse
          cx="573.376"
          cy="163.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 573.376 163.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="573.376"
          cy="163.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 573.376 163.762)"
          fill="#0C6776"
        />
        <rect
          x="568.985"
          y="102.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 568.985 102.003)"
          fill="#0C6776"
        />
        <circle
          cx="570.44"
          cy="102.221"
          r="4.47008"
          transform="rotate(-2.79885 570.44 102.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter10_d_268_1373)">
        <path
          d="M308.53 135C304.661 135.19 300.831 134.057 297.727 131.712C293.236 128.317 286.719 128.063 281.876 131.094L279.528 132.562C279.112 132.825 278.589 132.843 278.155 132.616C277.72 132.39 277.438 131.948 277.414 131.459L276.299 108.629C276.274 108.129 276.523 107.656 276.946 107.391L279.294 105.921C285.179 102.236 292.804 102.541 298.277 106.676C301.829 109.36 306.746 110.136 311.108 108.697C311.518 108.56 311.967 108.626 312.323 108.871C312.678 109.116 312.9 109.511 312.921 109.943L314.037 132.772C314.067 133.393 313.68 133.956 313.089 134.151C311.592 134.644 310.057 134.924 308.53 135L308.53 135Z"
          fill="#FEC077"
        />
        <ellipse
          cx="279.376"
          cy="161.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 279.376 161.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="279.376"
          cy="161.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 279.376 161.762)"
          fill="#0C6776"
        />
        <rect
          x="274.985"
          y="100.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 274.985 100.003)"
          fill="#0C6776"
        />
        <circle
          cx="276.44"
          cy="100.221"
          r="4.47008"
          transform="rotate(-2.79885 276.44 100.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter11_d_268_1373)">
        <path
          d="M258.53 260C254.661 260.19 250.831 259.057 247.727 256.712C243.236 253.317 236.719 253.063 231.876 256.094L229.528 257.562C229.112 257.825 228.589 257.843 228.155 257.616C227.72 257.39 227.438 256.948 227.414 256.459L226.299 233.629C226.274 233.129 226.523 232.656 226.946 232.391L229.294 230.921C235.179 227.236 242.804 227.541 248.277 231.676C251.829 234.36 256.746 235.136 261.108 233.697C261.518 233.56 261.967 233.626 262.323 233.871C262.678 234.116 262.9 234.511 262.921 234.943L264.037 257.772C264.067 258.393 263.679 258.956 263.089 259.151C261.592 259.644 260.057 259.924 258.529 260L258.53 260Z"
          fill="#FEC077"
        />
        <ellipse
          cx="229.376"
          cy="286.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 229.376 286.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="229.376"
          cy="286.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 229.376 286.762)"
          fill="#0C6776"
        />
        <rect
          x="224.985"
          y="225.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 224.985 225.003)"
          fill="#0C6776"
        />
        <circle
          cx="226.44"
          cy="225.221"
          r="4.47008"
          transform="rotate(-2.79885 226.44 225.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter12_d_268_1373)">
        <path
          d="M747.53 288C743.661 288.19 739.831 287.057 736.727 284.712C732.236 281.317 725.719 281.063 720.876 284.094L718.528 285.562C718.112 285.825 717.589 285.843 717.155 285.616C716.72 285.39 716.438 284.948 716.414 284.459L715.299 261.629C715.274 261.129 715.523 260.656 715.946 260.391L718.294 258.921C724.179 255.236 731.804 255.541 737.277 259.676C740.829 262.36 745.746 263.136 750.108 261.697C750.518 261.56 750.967 261.626 751.323 261.871C751.678 262.116 751.9 262.511 751.921 262.943L753.037 285.772C753.067 286.393 752.679 286.956 752.089 287.151C750.592 287.644 749.057 287.924 747.529 288L747.53 288Z"
          fill="#FEC077"
        />
        <ellipse
          cx="718.376"
          cy="314.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 718.376 314.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="718.376"
          cy="314.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 718.376 314.762)"
          fill="#0C6776"
        />
        <rect
          x="713.985"
          y="253.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 713.985 253.003)"
          fill="#0C6776"
        />
        <circle
          cx="715.44"
          cy="253.221"
          r="4.47008"
          transform="rotate(-2.79885 715.44 253.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter13_d_268_1373)">
        <path
          d="M632.53 442C628.661 442.19 624.831 441.057 621.727 438.712C617.236 435.317 610.719 435.063 605.876 438.094L603.528 439.562C603.112 439.825 602.589 439.843 602.155 439.616C601.72 439.39 601.438 438.948 601.414 438.459L600.299 415.629C600.274 415.129 600.523 414.656 600.946 414.391L603.294 412.921C609.179 409.236 616.804 409.541 622.277 413.676C625.829 416.36 630.746 417.136 635.108 415.697C635.518 415.56 635.967 415.626 636.323 415.871C636.678 416.116 636.9 416.511 636.921 416.943L638.037 439.772C638.067 440.393 637.679 440.956 637.089 441.151C635.592 441.644 634.057 441.924 632.529 442L632.53 442Z"
          fill="#FEC077"
        />
        <ellipse
          cx="603.376"
          cy="468.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 603.376 468.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="603.376"
          cy="468.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 603.376 468.762)"
          fill="#0C6776"
        />
        <rect
          x="598.985"
          y="407.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 598.985 407.003)"
          fill="#0C6776"
        />
        <circle
          cx="600.44"
          cy="407.221"
          r="4.47008"
          transform="rotate(-2.79885 600.44 407.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter14_d_268_1373)">
        <path
          d="M481.53 176C477.661 176.19 473.831 175.057 470.727 172.712C466.236 169.317 459.719 169.063 454.876 172.094L452.528 173.562C452.112 173.825 451.589 173.843 451.155 173.616C450.72 173.39 450.438 172.948 450.414 172.459L449.299 149.629C449.274 149.129 449.523 148.656 449.946 148.391L452.294 146.921C458.179 143.236 465.804 143.541 471.277 147.676C474.829 150.36 479.746 151.136 484.108 149.697C484.518 149.56 484.967 149.626 485.323 149.871C485.678 150.116 485.9 150.511 485.921 150.943L487.037 173.772C487.067 174.393 486.679 174.956 486.089 175.151C484.592 175.644 483.057 175.924 481.529 176L481.53 176Z"
          fill="#FEC077"
        />
        <ellipse
          cx="452.376"
          cy="202.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 452.376 202.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="452.376"
          cy="202.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 452.376 202.762)"
          fill="#0C6776"
        />
        <rect
          x="447.985"
          y="141.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 447.985 141.003)"
          fill="#0C6776"
        />
        <circle
          cx="449.44"
          cy="141.221"
          r="4.47008"
          transform="rotate(-2.79885 449.44 141.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter15_d_268_1373)">
        <path
          d="M796.237 387.704C792.368 387.893 788.538 386.76 785.434 384.415C780.943 381.02 774.425 380.767 769.582 383.798L767.235 385.266C766.819 385.528 766.295 385.547 765.861 385.319C765.426 385.093 765.145 384.652 765.121 384.163L764.006 361.332C763.981 360.832 764.229 360.36 764.652 360.094L767 358.624C772.885 354.939 780.511 355.244 785.983 359.38C789.535 362.063 794.453 362.839 798.815 361.401C799.224 361.263 799.674 361.329 800.03 361.574C800.385 361.819 800.606 362.215 800.628 362.646L801.744 385.475C801.774 386.097 801.386 386.66 800.796 386.855C799.298 387.347 797.764 387.628 796.236 387.704L796.237 387.704Z"
          fill="#FEC077"
        />
        <ellipse
          cx="767.083"
          cy="414.466"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 767.083 414.466)"
          fill="#BADED9"
        />
        <ellipse
          cx="767.083"
          cy="414.465"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 767.083 414.465)"
          fill="#0C6776"
        />
        <rect
          x="762.692"
          y="352.707"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 762.692 352.707)"
          fill="#0C6776"
        />
        <circle
          cx="764.147"
          cy="352.924"
          r="4.47008"
          transform="rotate(-2.79885 764.147 352.924)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter16_d_268_1373)">
        <path
          d="M857.53 480.001C853.661 480.19 849.831 479.057 846.727 476.712C842.236 473.317 835.718 473.063 830.875 476.094L828.528 477.563C828.112 477.825 827.589 477.844 827.154 477.616C826.72 477.39 826.438 476.949 826.414 476.46L825.299 453.629C825.274 453.129 825.522 452.656 825.946 452.391L828.294 450.921C834.178 447.236 841.804 447.541 847.276 451.677C850.829 454.36 855.746 455.136 860.108 453.698C860.517 453.56 860.967 453.626 861.323 453.871C861.678 454.116 861.9 454.511 861.921 454.943L863.037 477.772C863.067 478.393 862.679 478.956 862.089 479.151C860.592 479.644 859.057 479.925 857.529 480L857.53 480.001Z"
          fill="#FEC077"
        />
        <ellipse
          cx="828.376"
          cy="506.763"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 828.376 506.763)"
          fill="#BADED9"
        />
        <ellipse
          cx="828.376"
          cy="506.762"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 828.376 506.762)"
          fill="#0C6776"
        />
        <rect
          x="823.985"
          y="445.003"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 823.985 445.003)"
          fill="#0C6776"
        />
        <circle
          cx="825.44"
          cy="445.221"
          r="4.47008"
          transform="rotate(-2.79885 825.44 445.221)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter17_d_268_1373)">
        <path
          d="M890.711 149.028C886.842 149.217 883.012 148.084 879.908 145.739C875.417 142.344 868.899 142.09 864.056 145.121L861.709 146.59C861.293 146.852 860.77 146.87 860.335 146.643C859.901 146.417 859.619 145.975 859.595 145.487L858.48 122.656C858.455 122.156 858.703 121.683 859.127 121.418L861.475 119.948C867.359 116.263 874.985 116.568 880.457 120.703C884.01 123.387 888.927 124.163 893.289 122.724C893.698 122.587 894.148 122.653 894.504 122.898C894.859 123.143 895.081 123.538 895.102 123.97L896.218 146.799C896.248 147.42 895.86 147.983 895.27 148.178C893.773 148.671 892.238 148.951 890.71 149.027L890.711 149.028Z"
          fill="#FEC077"
        />
        <ellipse
          cx="861.557"
          cy="175.79"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 861.557 175.79)"
          fill="#BADED9"
        />
        <ellipse
          cx="861.557"
          cy="175.789"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 861.557 175.789)"
          fill="#0C6776"
        />
        <rect
          x="857.166"
          y="114.03"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 857.166 114.03)"
          fill="#0C6776"
        />
        <circle
          cx="858.621"
          cy="114.247"
          r="4.47008"
          transform="rotate(-2.79885 858.621 114.247)"
          fill="#0C6776"
        />
      </g>
      <g filter="url(#filter18_d_268_1373)">
        <path
          d="M849.067 243.597C845.198 243.787 841.368 242.654 838.263 240.309C833.773 236.914 827.255 236.66 822.412 239.691L820.065 241.159C819.649 241.422 819.125 241.44 818.691 241.213C818.256 240.987 817.975 240.545 817.951 240.056L816.835 217.226C816.811 216.726 817.059 216.253 817.482 215.988L819.83 214.518C825.715 210.832 833.341 211.138 838.813 215.273C842.365 217.957 847.283 218.733 851.645 217.294C852.054 217.157 852.504 217.223 852.86 217.468C853.215 217.712 853.436 218.108 853.457 218.54L854.573 241.368C854.604 241.99 854.216 242.553 853.626 242.748C852.128 243.241 850.594 243.521 849.066 243.597L849.067 243.597Z"
          fill="#FEC077"
        />
        <ellipse
          cx="819.912"
          cy="270.359"
          rx="13.1651"
          ry="7.31393"
          transform="rotate(-2.79885 819.912 270.359)"
          fill="#BADED9"
        />
        <ellipse
          cx="819.913"
          cy="270.358"
          rx="4.39798"
          ry="2.44332"
          transform="rotate(-2.79885 819.913 270.358)"
          fill="#0C6776"
        />
        <rect
          x="815.522"
          y="208.599"
          width="2.73972"
          height="61.8601"
          rx="1.36986"
          transform="rotate(-2.79885 815.522 208.599)"
          fill="#0C6776"
        />
        <circle
          cx="816.976"
          cy="208.817"
          r="4.47008"
          transform="rotate(-2.79885 816.976 208.817)"
          fill="#0C6776"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_268_1373"
          x="103.416"
          y="64.5556"
          width="65.9391"
          height="91.4688"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_268_1373"
          x="56.5834"
          y="145.772"
          width="65.9393"
          height="91.4688"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_268_1373"
          x="47.3235"
          y="253.273"
          width="65.9393"
          height="91.4688"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_268_1373"
          x="130.908"
          y="367.124"
          width="65.9394"
          height="91.4683"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_268_1373"
          x="610.583"
          y="176.748"
          width="65.9387"
          height="91.4688"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_268_1373"
          x="358.222"
          y="254.22"
          width="65.9393"
          height="91.4688"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_268_1373"
          x="230.882"
          y="352.257"
          width="65.939"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_268_1373"
          x="430.039"
          y="380.623"
          width="65.9392"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_268_1373"
          x="466.222"
          y="276.22"
          width="65.9392"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_268_1373"
          x="560.222"
          y="93.2199"
          width="65.9392"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_268_1373"
          x="266.222"
          y="91.2199"
          width="65.9392"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d_268_1373"
          x="216.222"
          y="216.22"
          width="65.9392"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_d_268_1373"
          x="705.222"
          y="244.22"
          width="65.9391"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter13_d_268_1373"
          x="590.222"
          y="398.22"
          width="65.9392"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter14_d_268_1373"
          x="439.222"
          y="132.22"
          width="65.9392"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter15_d_268_1373"
          x="753.929"
          y="343.923"
          width="65.939"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter16_d_268_1373"
          x="815.222"
          y="436.22"
          width="65.939"
          height="91.4685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter17_d_268_1373"
          x="848.403"
          y="105.247"
          width="65.9391"
          height="91.4688"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
        <filter
          id="filter18_d_268_1373"
          x="806.758"
          y="199.816"
          width="65.9393"
          height="91.4688"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9.06118" dy="4.53059" />
          <feGaussianBlur stdDeviation="4.53059" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_268_1373"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_268_1373"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export const MapMobile = () => {
  return (
    <svg
      width="343"
      height="245"
      viewBox="0 0 343 245"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_378_1483"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="343"
        height="245"
      >
        <rect width="342.617" height="245" fill="#FFF5F0" />
      </mask>
      <g mask="url(#mask0_378_1483)">
        <g opacity="0.8">
          <path
            d="M256.749 181.882L260.959 180.43L275.286 177.008L274.898 176.424L274.149 175.427L274.002 173.94L273.823 172.476L273.05 171.004L272.784 168.135L273.554 166.468L272.664 165.259L270.989 162.864L267.325 155.019L263.136 145.345L254.546 147.228L246.272 149.026L246.959 150.276L246.963 150.332L248.003 161.416L249.542 175.038L252.379 187.581L258.63 187.164L258.857 186.117L258.875 184.532L256.784 182.86L256.749 181.882Z"
            fill="#0C6776"
          />
          <path
            d="M232.22 145.309L233.295 144.233L233.72 143.031L233.689 142.671L229.119 143.535L229.523 142.159L230.621 140.222L230.065 139.543L222.412 140.414L215.272 141.62L207.756 142.778L199.771 143.811L202.287 152.289L203.282 160.525L204.099 167.865L204.39 168.19L205.597 167.918L207.266 167.712L207.545 167.678L207.823 172.531L214.42 171.562L222.133 170.035L227.971 169.314L228.013 167.9L226.821 165.851L226.62 163.718L227.644 160.462L228.082 158.566L229.176 157.114L229.828 156.547L230.315 154.267L230.101 152.941L231.241 152.069L231.243 151.829L230.927 151.889L231.247 151.427L231.249 151.294L231.352 151.272L231.868 150.528L231.327 148.107L232.222 146.773L232.22 145.309Z"
            fill="#0C6776"
          />
          <path
            d="M90.8172 145.224L77.7144 144.567L66.9741 143.958L66.5056 150.649L66.146 150.939L65.5074 152.381L64.353 151.863L63.1089 151.169L61.8874 151.069L61.4717 151.816L61.9669 152.971L61.8056 154.862L61.8106 156.485L62.0188 158.219L61.4504 159.855L61.5194 160.549L61.8045 161.715L62.2523 163.221L63.0112 164.857L64.3511 166.795L61.9337 168.464L61.058 172.273L59.5421 174.068L59.767 175.48L59.9068 176.703L61.1451 178.063L60.0337 180.014L59.0835 179.922L58.4873 181.101L68.863 185.986L85.154 192.932L99.4078 193.362L100.46 145.575L90.8172 145.224Z"
            fill="#0C6776"
          />
          <path
            d="M58.7821 179.363L59.748 179.457L60.5003 178.131L59.4059 176.931L59.2467 175.548L58.988 173.91L60.5773 172.028L61.4716 168.142L63.6224 166.658L62.5463 165.098L61.7534 163.389L61.2985 161.849L61.0048 160.638L60.9312 159.932L50.3765 148.146L39.4602 135.586L28.3717 122.429L31.9931 97.3L6.07968 92.9037L4.95339 99.9115L2.26796 106.472L4.8047 111.65L4.42528 118.638L8.19896 126.491L10.711 129.859L10.1255 131.815L13.7516 144.324L19.0986 153.863L19.2468 158.574L20.7017 160.078L26.1533 161.522L28.8412 164.598L31.6168 165.283L38.6274 171.355L41.1894 176.178L41.6825 179.23L49.7214 179.432L58.7712 179.38L58.7821 179.363Z"
            fill="#0C6776"
          />
          <path
            d="M122.201 145.187L133.798 144.943L141.963 144.644L146.852 144.425L148.258 144.362L147.594 132.148L146.795 118.787L146.374 110.787L134.02 111.329L134.021 111.332L133.757 111.339L133.495 111.352L133.494 111.346L127.294 111.517L114.364 111.666L107.896 111.628L101.688 111.529L100.996 145.058L111.415 145.203L122.201 145.187Z"
            fill="#0C6776"
          />
          <path
            d="M327.449 62.2107L323.101 63.754L325.008 69.6335L325.902 70.2334L324.836 71.5882L325.148 72.06L328.934 68.5332L332.25 66.7612L334.567 65.3907L334.473 64.2923L332.78 60.2676L327.449 62.2107Z"
            fill="#0C6776"
          />
          <path
            d="M318.01 88.9239L317.967 88.9509L317.843 88.6987L317.069 87.0986L317.531 86.2185L316.635 86.2593L316.31 86.6844L316.105 87.3498L320.086 97.0771L323.67 95.7791L320.728 92.5811L318.01 88.9239Z"
            fill="#0C6776"
          />
          <path
            d="M55.5484 62.583L55.9514 63.9514L55.7414 65.4164L56.8914 67.0981L57.8707 67.9393L58.0815 69.4649L57.3133 70.5845L56.2779 72.6755L55.1045 75.3677L53.6019 76.9156L52.5764 78.6789L52.4355 79.8184L53.4551 80.4807L53.8854 81.8179L53.0631 84.2279L51.3245 99.1696L62.7917 100.284L70.0056 100.984L88.6795 102.047L89.6063 81.2354L89.5101 81.1601L89.3421 81.0313L89.3417 81.0282L88.8059 80.6117L88.2818 79.4227L87.9446 79.2835L87.0414 80.8516L85.4522 81.0764L82.2325 80.3962L82.0198 81.2273L79.9214 80.768L78.5417 82.049L77.4609 79.4046L76.8562 78.2441L75.6323 77.9455L75.2298 77.1428L75.0085 74.919L74.021 73.7803L73.5262 70.996L72.9562 69.8903L72.5468 69.7195L71.9301 70.7304L70.4451 71.8099L69.1932 70.6443L69.3236 68.1942L70.0367 67.7187L69.7355 65.5792L70.513 63.3114L71.1864 61.7713L69.6766 61.576L68.1642 60.1096L66.7463 57.2762L65.9256 55.9244L64.6584 54.9907L63.6314 53.3999L63.7835 51.8425L62.4873 49.4201L62.9131 40.5174L57.8472 39.9939L56.6895 50.6984L55.5484 62.583Z"
            fill="#0C6776"
          />
          <path
            d="M235.237 88.1804L234.771 86.2195L230.231 87.0992L223.765 88.3754L217.871 89.4822L217.981 89.6119L218.017 89.6542L218.859 89.9588L219.328 90.8187L220.403 91.3032L221.279 91.9861L221.371 94.4774L220.544 96.6394L220.194 97.4158L218.734 98.2185L216.777 98.97L216.533 100.184L217.349 100.651L217.921 102.079L217.322 103.75L217.117 105.152L215.721 106.659L215.833 107.958L215.863 107.973L215.85 108.12L215.891 108.588L215.811 108.542L215.654 110.261L216.619 112.572L217.951 114.06L219.403 115.236L221.076 116.082L221.812 116.381L222.714 118.019L223.035 119.251L223.581 119.396L224.776 118.588L226.534 119.897L226.434 121.709L226.059 123.02L225.921 124.414L226.976 125.392L228.403 126.26L229.173 126.147L231.297 127.679L232.092 127.806L233.064 129.914L233.065 131.191L234.145 132.813L234.758 132.487L235.571 133.081L235.392 132.658L235.772 131.471L237.894 131.582L239.506 131.986L240.036 131.358L239.387 129.55L240.9 128.421L241.694 127.768L241.054 127.183L241.592 125.784L241.491 125.442L241.45 125.438L241.432 125.238L241.339 124.907L241.408 124.911L241.287 123.409L241.751 120.915L242.702 118.844L242.879 117.339L243.295 116.748L243.128 115.786L243.125 115.764L242.518 114.507L241.784 113.966L242.026 111.384L237.862 92.194L235.237 88.1804Z"
            fill="#0C6776"
          />
          <path
            d="M256.669 95.9381L254.73 88.0662L249.155 89.4638L242.514 90.9633L241.039 92.2529L238.756 92.8078L238.497 92.6466L242.555 111.349L242.334 113.717L242.932 114.16L243.637 115.635L243.847 116.871L243.386 117.531L243.195 119.024L242.242 121.102L241.809 123.468L241.934 124.929L242.287 124.942L242.153 123.97L244.209 124.282L245.447 123.04L247.663 123.827L247.919 123.09L249.432 121.808L250.981 122.431L251.392 121.563L252.327 119.211L253.199 120.451L254.356 120.76L255.17 118.1L256.037 117.618L256.538 116.033L257.26 115.255L256.99 113.469L258.773 113.386L259.587 112.432L260.587 112.17L260.667 111.753L259.694 110.152L259.991 109.625L256.669 95.9381Z"
            fill="#0C6776"
          />
          <path
            d="M243.584 191.405L243.302 190.643L242.802 189.377L241.682 188.599L240.929 187.497L241.156 185.946L241.108 184.833L234.555 186.039L227.856 186.936L227.095 184.545L227.856 183.392L228.155 181.301L228.507 179.346L229.656 177.804L229.703 176.147L230.457 175.216L229.349 174.011L229.461 172.909L228.097 171.335L228.512 170.053L228.168 169.825L222.219 170.556L214.516 172.085L207.891 173.057L209.559 181.664L210.851 182.427L211.479 183.752L212.383 185.61L213.496 187.393L214.371 188.524L214.104 191.898L213.778 192.867L213.465 194.817L214.049 195.275L214.307 197.186L213.321 198.534L212.82 199.727L213.414 200.522L219.779 199.818L225.652 200.022L230.219 201.048L236.792 201.665L246.529 199.495L243.415 195.121L243.584 191.405Z"
            fill="#0C6776"
          />
          <path
            d="M342.684 55.5074L344.22 57.6736L341.224 58.6791L337.37 55.1882L335.732 51.138L335.279 51.2212L334.376 52.1582L334.08 53.2482L327.313 55.9289L327.326 55.9366L326.888 56.0956L326.749 56.1499L326.745 56.1472L322.206 57.7979L322.984 63.2399L327.272 61.7193L332.824 59.6966L335.461 58.5016L336.83 60.5017L338.143 61.0225L338.743 62.0467L341.392 61.099L344.668 58.2655L344.232 56.1176L342.684 55.5074Z"
            fill="#0C6776"
          />
          <path
            d="M294.602 98.0484L295.408 96.7345L296.543 96.0242L297.14 94.8479L299.106 94.5741L299.572 93.8085L300.453 92.927L298.739 93.5027L293.165 95.264L294.174 98.6446L294.602 98.0484Z"
            fill="#0C6776"
          />
          <path
            d="M324.439 96.5528L324.069 96.1938L319.79 97.7412L315.678 87.691L310.461 89.5547L305.126 91.3366L301.042 92.7234L302.995 92.7279L304.24 93.7078L304.994 94.4895L305.935 94.4557L306.999 94.7924L307.229 94.8669L307.196 95.0793L307.074 95.8154L308.341 95.8598L309.625 96.294L310.02 95.7081L311.559 96.4998L310.898 97.6561L311.012 98.3603L310.179 99.5065L310.173 99.5103L310.119 100.493L310.081 101.234L310.725 101.333L311.759 100.539L312.617 101.684L316.686 102.624L314.313 96.1114L314.351 92.8767L314.858 92.7806L317.219 98.6267L321.463 101.112L321.644 100.683L321.689 100.569L321.693 100.568L321.79 100.522L323.115 99.9164L324.439 96.5528Z"
            fill="#0C6776"
          />
          <path
            d="M348.538 24.0656L342.913 21.3344L338.025 10.707L334.877 9.62327L331.88 12.5843L329.323 11.3696L327.883 18.7419L328.849 25.5912L328.403 30.1192L326.731 32.3934L333.421 46.3453L333.517 47.1107L334.997 47.8009L335.626 48.6507L335.896 48.4934L336.861 43.8089L341.305 36.1948L345.91 31.9154L350.044 27.0902L348.538 24.0656Z"
            fill="#0C6776"
          />
          <path
            d="M214.033 54.4016L214.789 55.8298L220.09 56.3433L223.718 57.1633L225.318 56.844L226.692 56.689L227.327 58.0479L228.797 58.279L229.709 59.5389L229.71 59.5419L229.47 60.3795L229.486 61.4532L230.84 61.2415L230.841 61.2446L230.677 62.8843L231.416 63.4875L233.65 57.5354L237.54 55.8394L241.735 53.0681L246.75 52.8144L251.178 50.9628L247.658 48.5317L248.058 47.7525L246.761 47.9042L246.612 48.8209L244.429 48.9439L242.681 46.9466L237.402 48.961L232.595 52.0681L227.726 49.7205L223.993 49.3144L224.812 44.9399L220.897 48.299L216.809 51.9495L213.552 54.3486L214.033 54.4016Z"
            fill="#0C6776"
          />
          <path
            d="M246.125 54.7404L246.09 57.9281L245.001 59.093L244.96 63.3508L244.457 63.4587L243.421 61.2037L241.825 63.3661L241.017 66.4491L240.409 70.8476L240.907 74.3496L244.107 79.0239L245.239 84.6683L243.609 89.4246L242.995 90.3077L249.037 88.9433L255.113 87.4195L255.274 88.0588L258.172 87.2704L260.99 86.5446L263.162 85.8975L264.372 82.3055L264.939 79.0498L266.528 73.826L265.329 70.6396L263.009 66.2995L260.886 66.1012L258.174 70.6815L256.639 70.9898L255.656 68.6691L258.084 64.4561L257.634 60.6653L256.207 57.1708L251.177 55.1289L246.125 54.7404Z"
            fill="#0C6776"
          />
          <path
            d="M170.669 40.5703L171.343 41.7659L171.421 42.8662L171.346 43.9603L171.6 45.6051L171.86 47.103L172.678 48.5608L173.599 50.3014L174.083 52.002L174.314 53.0277L174.469 54.2026L174.979 56.6244L175.236 57.0749L175.532 59.044L176.005 60.7087L176.646 62.014L177.187 63.316L177.339 64.6344L177.363 64.6314L177.37 64.9166L177.399 65.1586L177.378 65.1612L177.414 66.3008L176.165 67.4262L176.004 68.4312L176.658 69.5299L177.827 70.0931L179.536 78.2787L180.354 85.9822L186.837 85.1984L195.19 83.9441L204.156 82.5218L211.912 81.3682L211.679 80.7095L211.316 78.7207L211.058 78.1863L208.83 77.3044L207.015 76.0862L206.442 75.2577L205.732 74.8375L203.654 73.9871L202.891 74.0303L200.689 72.564L200.573 70.5449L200.212 68.2448L200.326 66.1419L198.787 64.7159L199.467 62.7988L202.012 60.5176L201.188 55.846L202.654 55.1171L202.474 53.9484L205.868 49.6082L209.398 45.4381L214.163 41.9351L207.486 41.1229L203.055 43.0526L197.034 41.2993L191.058 40.8369L186.967 40.8848L184.856 39.5876L183.258 35.1253L181.831 35.3521L182.253 38.6644L170.56 40.0553L170.669 40.5703Z"
            fill="#0C6776"
          />
          <path
            d="M64.3251 51.7321L64.1734 53.2677L65.0504 54.6219L66.3244 55.5609L67.2083 57.0232L68.5969 59.7949L69.9188 61.0763L71.9494 61.3356L71.0042 63.5026L70.2746 65.6278L70.6069 67.9717L69.8363 68.4854L69.7339 70.4253L70.488 71.1293L71.5358 70.3643L72.3313 69.0611L73.3394 69.4761L74.0371 70.8647L74.5162 73.5452L75.5178 74.6977L75.7449 76.9955L75.9949 77.4904L77.2154 77.7862L77.9391 79.184L78.7407 81.1444L79.7661 80.1955L81.6377 80.6047L81.8504 79.7736L85.4695 80.5419L86.7132 80.3654L87.7191 78.62L88.681 79.0126L89.2363 80.2786L89.5315 80.5069L89.7037 76.0278L101.915 76.3801L111.362 76.609L122.288 76.5209L132.154 76.3786L132.202 69.5551L132.207 68.7804L131.565 58.3604L130.976 42.7857L114.206 43.0605L97.1671 42.7806L80.1465 41.942L63.4399 40.5646L63.0214 49.2984L64.3251 51.7321Z"
            fill="#0C6776"
          />
          <path
            d="M317.549 115.698L310.677 118.089L297.612 122.209L287.743 124.792L286.607 125.089L286.704 125.911L287.17 127.237L285.816 128.037L285.159 129.764L283.905 129.933L281.775 132.275L281.04 131.703L279.923 132.977L280.127 133.58L278.936 134.667L278.465 135.576L277.036 136.76L275.551 137.557L274.303 138.107L273.668 139.248L273.416 140.317L272.167 141.165L272.389 142.506L277.117 141.302L280.531 140.435L281.101 140.039L284.395 137.605L290.703 135.894L294.174 135.322L294.336 135.762L294.723 135.211L296.475 136.499L296.695 137.287L304.039 135.145L313.997 140.429L316.062 139.266L320.456 133.284L325.874 127.973L327.909 120.69L324.269 113.296L317.549 115.698Z"
            fill="#0C6776"
          />
          <path
            d="M132.72 68.4977L143.882 67.9737L156.122 67.1379L165.81 66.3271L176.817 64.709L176.669 63.4461L176.166 62.2266L175.5 60.8714L175.012 59.1371L174.726 57.2476L174.472 56.7687L173.949 54.2864L173.794 53.1177L173.567 52.1287L173.098 50.4668L172.212 48.8089L171.354 47.2782L171.079 45.6858L170.814 43.977L170.891 42.8454L170.825 41.9177L170.158 40.7118L170.032 40.1055L150.959 41.7896L131.504 42.7647L132.093 58.3332L132.72 68.4977Z"
            fill="#0C6776"
          />
          <path
            d="M181.248 95.7709L180.942 95.1211L179.973 95.1273L179.262 94.7072L178.914 94.0688L177.177 93.5624L175.519 92.6857L173.38 92.996L171.961 93.1099L171.434 93.5814L168.864 93.0771L167.217 92.1928L154.772 93.2121L145.386 93.7964L133.419 94.3191L133.874 107.134L134.007 110.802L146.874 110.238L147.329 118.766L158.495 118.042L166.973 117.354L181.953 115.833L190.481 114.794L189.65 113.487L188.543 112.559L187.226 111.298L186.994 110.565L186.365 109.05L186.358 107.49L186.049 106.101L185.107 103.778L184.615 102.909L184.069 102.664L183.772 100.605L183.236 99.3244L181.867 97.8343L181.797 97.0842L181.248 95.7709Z"
            fill="#0C6776"
          />
          <path
            d="M326.286 38.8347L326.498 40.0836L325.5 41.6664L324.663 42.4025L324.763 43.0899L325.153 44.432L325.225 46.6833L325.041 47.5389L325.045 49.3105L325.599 51.2574L325.618 51.8209L326.312 53.9654L326.269 55.093L326.841 55.5487L333.641 52.8577L333.903 51.8932L335.015 50.738L335.653 50.6167L335.81 49.1489L335.772 49.1721L335.482 49.3412L334.652 48.2205L333.03 47.4637L332.906 46.4965L326.311 32.7321L324.949 33.5229L325.155 35.3444L325.161 35.3437L325.189 35.5424L325.408 37.8784L326.286 38.8347Z"
            fill="#0C6776"
          />
          <path
            d="M322.715 78.2272L323.343 73.4533L322.577 73.2668L317.915 72.1313L317.471 72.5928L317.08 74.745L316.444 75.6931L317.116 76.5717L316.751 77.8567L317.105 78.8986L317.83 78.9035L318.281 79.778L321.107 81.2057L320.523 82.6385L319.471 84.2092L319.205 84.8821L318.201 86.0832L317.661 87.1096L318.201 88.2221L318.611 87.9918L320.922 89.5848L322.5 89.4951L323.488 91.0193L325.529 83.816L324.464 77.9862L322.715 78.2272Z"
            fill="#0C6776"
          />
          <path
            d="M117.106 187.878L123.965 187.816L137.096 187.5L143.594 187.246L141.91 149.15L141.86 148.071L141.725 145.181L133.817 145.467L122.207 145.713L111.413 145.729L100.987 145.585L100.988 145.591L100.985 145.592L99.9311 193.372L105.31 193.45L105.448 189.92L117.839 189.968L117.228 188.957L117.106 187.878Z"
            fill="#0C6776"
          />
          <path
            d="M66.4889 143.406L66.492 143.405L66.5016 143.255L69.7086 101.486L51.2472 99.6912L51.2449 99.6977L51.2414 99.7199L51.0015 99.69L42.2063 98.592L32.5114 97.3797L28.9267 122.273L39.8593 135.248L50.7685 147.802L61.0815 159.317L61.485 158.164L61.2854 156.5L61.2824 154.843L61.4319 153.059L60.888 151.786L61.5947 150.518L63.2685 150.656L64.5925 151.393L65.2435 151.684L65.7188 150.609L65.9989 150.383L66.4528 143.929L66.4498 143.93L66.4705 143.666L66.4889 143.406Z"
            fill="#0C6776"
          />
          <path
            d="M325.254 72.6812L325.054 72.8705L324.186 71.5649L325.139 70.3575L324.564 69.9737L322.606 63.9356L322.555 63.9511L322.513 63.6578L322.442 63.4333L322.481 63.4192L321.658 57.6874L319.443 51.2951L318.667 51.5328L318.272 51.0741L318.193 49.7625L316.854 47.8801L316.79 46.01L316.025 44.9344L314.948 42.5537L314.78 41.455L314.355 40.0799L306.072 43.2811L304.095 45.6329L300.197 53.0593L301.185 53.9772L302.733 57.1865L299.085 61.5887L293.926 62.5749L289.24 63.7865L286.727 65.6161L288.16 67.5305L288.173 67.5788L288.586 68.4237L284.929 74.9192L285.503 76.7675L294.699 73.8343L303.472 70.8719L311.714 67.9679L313.568 68.7927L314.676 69.3167L314.852 70.3243L315.56 71.2111L316.687 71.3754L317.738 71.5581L317.746 71.5478L317.884 71.5808L318.364 71.6653L318.336 71.6935L323.754 73.0136L323.856 73.0384L323.924 73.0551L323.897 73.2448L324.417 75.7027L327.943 74.3279L334.995 68.9327L333.201 68.3431L325.254 72.6812Z"
            fill="#0C6776"
          />
          <path
            d="M263.376 86.3904L261.132 87.0587L258.308 87.7884L255.404 88.5806L257.185 95.8155L260.472 109.367L262.551 109.033L264.005 109.589L266.152 110.982L267.66 111.211L268.732 111.584L270.182 110.963L271.418 111.129L272.643 110.337L274.003 109.792L274.905 110.891L276.157 111.295L277.506 110.726L277.96 109.533L277.558 107.711L278.013 105.423L279.329 105.359L279.59 106.045L279.701 105.932L279.676 105.189L279.507 103.575L280.636 101.562L281.532 101.518L282.238 101.09L282.801 100.534L283.916 98.2775L283.78 97.464L283.869 95.4915L283.883 93.208L283.624 91.312L282.965 90.2141L283.74 89.5133L280.63 79.0957L278.139 80.8947L275.153 84.2245L270.916 86.6279L267.631 87.0656L263.376 86.3904Z"
            fill="#0C6776"
          />
          <path
            d="M284.287 89.4923L286.47 96.7683L292.763 94.8386L298.576 92.9985L300.548 92.3416L304.963 90.8399L310.292 89.0587L315.616 87.1571L315.839 86.4366L316.367 85.7443L317.854 85.678L318.75 84.6052L319.02 83.9381L320.072 82.3674L320.439 81.4553L317.892 80.1678L317.509 79.4249L316.728 79.4175L316.2 77.8683L316.537 76.677L315.797 75.7102L316.584 74.5386L316.984 72.3385L317.296 72.0145L316.607 71.8934L315.28 71.7006L314.36 70.5476L314.207 69.674L313.352 69.2713L311.692 68.5317L303.644 71.3685L294.866 74.3347L285.161 77.4263L284.854 76.4408L284.526 75.3803L281.077 78.7385L283.989 88.4998L284.287 89.4923Z"
            fill="#0C6776"
          />
          <path
            d="M336.485 60.9346L335.271 59.1643L333.262 60.0745L334.989 64.1728L335.057 65.0102L338.285 62.3101L337.779 61.4484L336.485 60.9346Z"
            fill="#0C6776"
          />
          <path
            d="M299.233 157.269L300.456 158.708L300.87 160.169L301.425 160.257L302.613 160.317L308.527 154.072L312.904 147.209L313.717 140.873L303.985 135.708L296.33 137.941L296.021 136.812L294.847 135.955L294.198 136.882L293.835 135.913L290.802 136.413L284.63 138.086L281.41 140.465L280.837 140.864L280.321 141.679L279.746 143.266L281.683 144.034L283.068 144.223L285.115 146.557L286.286 147.745L289.226 149.038L289.984 149.928L292 150.807L293.354 152.529L296.057 153.565L297.127 155.355L297.86 156.214L297.806 156.793L299.233 157.269Z"
            fill="#0C6776"
          />
          <path
            d="M176.873 66.0776L176.849 65.2411L165.867 66.8563L156.158 67.6696L143.911 68.5093L132.73 69.0295L132.71 72.1066L132.678 76.64L133.245 90.2717L133.393 93.8009L145.354 93.2789L154.73 92.6957L167.322 91.6647L169.072 92.6017L171.271 93.0238L171.737 92.6095L173.316 92.4793L175.604 92.1506L177.392 93.0924L179.263 93.629L179.648 94.3376L180.11 94.6077L180.812 94.603L180.77 94.232L179.603 93.3763L179.982 91.7725L180.147 90.3909L180.181 89.5784L179.271 88.5608L179.005 86.1497L179.826 86.0496L179.01 78.3645L177.357 70.461L176.28 69.9364L175.447 68.5394L175.668 67.1632L176.873 66.0776Z"
            fill="#0C6776"
          />
          <path
            d="M315.464 42.4378L316.495 44.6936L317.314 45.8311L317.375 47.7045L318.71 49.5812L318.789 50.8649L318.843 50.9266L319.772 50.6424L322.077 57.2849L326.266 55.764L325.732 55.3348L325.785 54.0382L325.097 51.9117L325.077 51.339L324.521 49.3828L324.522 47.4521L324.705 46.6029L324.631 44.5165L324.248 43.1829L324.105 42.193L325.125 41.2978L325.945 39.9728L325.796 39.0741L324.903 38.104L324.701 35.9339L314.849 39.8889L315.299 41.3544L315.464 42.4378Z"
            fill="#0C6776"
          />
          <path
            d="M17.2037 57.2284L18.5156 58.2747L20.1947 59.0929L21.0732 61.047L20.9764 62.523L21.1779 63.6145L22.335 64.1045L23.7188 64.3121L26.138 63.8058L27.5985 63.7491L29.7695 64.4979L30.5595 65.0358L31.7261 64.9403L33.2204 64.4473L35.8913 64.9612L38.1557 64.3588L39.4922 63.7948L40.9724 64.3854L43.1851 63.7924L55.2463 65.1889L55.4169 63.9867L55.0184 62.6301L56.1722 50.6447L57.3287 39.9308L40.793 37.8144L24.4456 35.1528L25.8306 42.3083L25.5492 49.5644L23.3181 52.0219L21.8697 44.5507L14.6815 41.7147L14.0875 49.6711L14.3283 56.7485L15.3623 56.8401L17.2037 57.2284Z"
            fill="#0C6776"
          />
          <path
            d="M203.031 73.4984L203.735 73.4592L205.976 74.3767L206.8 74.8638L207.385 75.7065L209.095 76.8536L211.436 77.7714L211.818 78.5921L212.187 80.5958L212.656 81.891L213.784 83.1929L213.302 84.004L213.609 85.6298L213.973 86.2973L214.556 87.4574L216.699 87.8958L217.497 89.014L223.661 87.8586L230.124 86.5828L234.616 85.7121L234.61 85.691L234.671 85.6805L234.434 83.8906L232.782 79.948L232.784 79.8917L232.921 74.9165L233.024 68.7453L234.586 62.0512L234.239 62.1401L230.956 68.6677L229.52 67.5184L231.202 63.9994L230.121 63.1176L230.12 63.1115L230.246 61.8713L228.968 62.0706L228.967 62.0676L228.95 60.2696L229.129 59.6417L228.497 58.7705L226.963 58.5284L226.37 57.2608L225.395 57.3703L223.777 57.6888L223.707 57.7035L223.611 57.681L219.982 56.861L214.453 56.3319L213.696 54.8975L212.928 54.814L212.916 54.8217L212.577 55.0775L212.367 54.9601L208.457 52.7942L203.224 55.4154L203.225 55.4215L201.767 56.1431L202.62 60.9698L202.24 61.0161L199.911 63.1031L199.393 64.5682L200.855 65.9259L200.733 68.2195L201.088 70.4892L201.193 72.2732L203.031 73.4984Z"
            fill="#0C6776"
          />
          <path
            d="M276.522 111.712L276.763 112.261L277.143 113.903L278.262 114.976L278.888 116.075L280.112 116.864L280.95 117.592L282.015 117.428L282.199 117.126L282.332 117.377L282.702 117.32L282.487 117.673L283.063 118.778L283.917 119.258L284.932 119.576L286.716 117.99L287.695 118.347L289.679 117.104L289.589 116.185L289.595 116.184L289.594 116.175L290.584 116.26L291.188 115.456L292.142 115.296L292.837 114.518L292.77 113.895L292.397 113.026L292.354 112.926L292.353 112.923L292.356 112.916L292.857 111.086L293.731 109.711L293.682 108.446L294.337 106.65L294.412 104.378L295.792 104.859L296.779 105.103L297.401 104.644L297.469 103.884L298.184 101.027L298.797 101.235L299.318 100.074L300.216 98.6152L300.692 97.6464L300.459 95.0199L304.457 96.174L304.611 94.8558L304.347 94.5833L303.874 94.0938L302.815 93.2592L300.872 93.2566L299.965 94.1598L299.429 95.0646L297.484 95.3327L296.945 96.3932L295.793 97.1181L295.038 98.3418L293.975 99.8237L292.664 95.4227L286.116 97.4301L283.907 90.0702L283.639 90.3144L284.13 91.1312L284.409 93.1708L284.395 95.5041L284.307 97.4299L284.46 98.3594L283.234 100.844L282.536 101.525L281.691 102.036L280.949 102.073L280.045 103.685L280.199 105.152L280.236 106.14L279.389 106.998L278.973 105.905L278.447 105.929L278.095 107.703L278.506 109.571L277.918 111.123L276.522 111.712Z"
            fill="#0C6776"
          />
          <path
            d="M89.1807 102.606L88.8081 110.365L101.439 111.001L107.902 111.106L114.361 111.143L127.282 110.998L133.476 110.824L133.337 106.955L132.877 94.0786L132.165 76.9049L122.293 77.0479L111.357 77.1371L101.9 76.9094L90.2068 76.5718L90.0487 80.7072L89.9835 80.8613L90.1446 80.9846L89.2054 102.077L89.1936 102.312L89.1807 102.606Z"
            fill="#0C6776"
          />
          <path
            d="M212.216 199.804L212.879 198.252L213.759 197.051L213.558 195.561L212.895 195.045L213.275 192.723L213.596 191.764L213.831 188.689L213.056 187.686L211.916 185.857L210.446 182.803L209.089 181.998L207.371 173.136L207.335 173.141L207.318 172.872L207.271 172.617L207.305 172.613L207.056 168.275L205.689 168.442L204.21 168.774L203.696 168.209L200.491 166.986L198.513 166.388L197.032 167.143L194.486 167.373L193.093 167.555L191.969 168.382L190.744 168.914L189.641 168.616L187.247 169.374L186.12 168.19L185.239 169.411L183.009 169.017L181.01 167.971L178.868 169.09L177.702 167.074L174.572 167.568L172.389 167.302L169.848 166.884L168.705 165.292L166.983 165.981L165.672 165.326L163.788 164.486L162.523 148.16L155.925 148.632L149.056 149.052L142.446 149.382L144.144 187.756L137.115 188.032L123.974 188.346L117.695 188.402L117.736 188.789L118.522 190.08L121.182 193.06L124.958 195.703L129.48 199.439L132.095 203.936L134.055 208.54L137.938 210.961L144.089 213.221L148.48 206.269L154.812 205.753L160.441 208.909L164.674 214.583L167.676 219.421L172.614 223.999L174.833 229.933L177.298 233.709L183.553 235.803L189.227 237.129L191.821 236.63L190.201 234.129L189.36 229.96L189.359 229.944L188.794 223.932L190.17 219.77L193.964 215.111L201.009 210.524L207.025 203.275L212.884 200.696L212.216 199.804Z"
            fill="#0C6776"
          />
          <path
            d="M90.8402 144.696L100.471 145.049L101.165 111.513L88.2619 110.86L88.6568 102.571L87.0697 102.481L70.23 101.521L67.6138 135.611L67.0125 143.432L77.7407 144.039L90.8402 144.696Z"
            fill="#0C6776"
          />
          <path
            d="M155.887 148.102L163.003 147.592L164.285 164.127L165.893 164.845L167.002 165.4L168.89 164.645L170.145 166.394L172.46 166.774L174.559 167.031L177.973 166.494L179.067 168.385L181.005 167.371L183.21 168.526L185.001 168.834L186.059 167.362L187.395 168.766L189.626 168.062L190.699 168.35L191.727 167.905L192.884 167.046L194.423 166.843L196.877 166.621L198.458 165.816L200.656 166.484L203.538 167.579L202.76 160.585L201.766 152.375L199.241 143.878L199.198 143.884L199.172 143.641L199.089 143.369L199.138 143.363L199.074 142.811L198.741 140.001L193.036 140.764L180.829 142.212L168.588 143.42L161.778 143.989L154.97 144.477L148.811 144.858L148.812 144.864L148.543 144.875L148.283 144.891L148.286 144.888L143.735 145.094L142.248 145.16L142.328 146.941L142.418 148.852L149.021 148.522L155.887 148.102Z"
            fill="#0C6776"
          />
          <path
            d="M32.3282 96.8252L50.8022 99.1344L52.553 84.114L52.5592 84.0884L52.5588 84.0854L53.3359 81.8144L53.0159 80.8213L51.8783 80.0832L52.0719 78.5083L53.207 76.5731L54.6651 75.0679L55.8046 72.4544L56.8726 70.3003L57.5355 69.3366L57.3793 68.2085L56.4819 67.4256L55.3208 65.7298L43.2248 64.3283L40.9401 64.9426L39.4992 64.3689L38.3069 64.8656L35.9099 65.5027L33.252 64.9935L31.8323 65.4619L30.4164 65.5785L29.5012 64.9563L27.5198 64.2838L26.2013 64.3326L23.7339 64.8509L22.1588 64.6046L20.713 63.9911L20.4484 62.5591L20.5373 61.1462L19.7941 59.4866L18.2099 58.7065L16.9735 57.7194L15.2702 57.3643L14.2672 57.272L10.8575 69.5729L8.61379 78.9924L5.03912 87.5419L6.07842 92.3707L32.3282 96.8252Z"
            fill="#0C6776"
          />
          <path
            d="M148.122 132.12L148.783 144.335L154.936 143.955L161.741 143.465L168.542 142.897L180.775 141.692L192.972 140.246L198.646 139.486L197.488 130.726L196.341 121.85L194.575 121.31L193.487 119.574L192.793 118.729L193.526 116.986L193.268 116.097L192.563 116.205L190.871 115.28L182.005 116.36L167.017 117.879L158.527 118.572L147.355 119.293L148.122 132.12Z"
            fill="#0C6776"
          />
          <path
            d="M247.481 161.475L246.444 150.441L245.729 149.142L238.339 150.465L231.773 151.735L231.766 152.339L230.671 153.175L230.853 154.287L230.309 156.838L229.544 157.5L228.571 158.8L228.154 160.607L227.154 163.782L227.334 165.693L228.542 167.772L228.497 169.416L229.133 169.839L228.689 171.221L230.003 172.742L229.893 173.831L231.151 175.198L230.221 176.347L230.173 177.991L229 179.567L228.669 181.389L228.359 183.587L227.671 184.632L228.221 186.362L234.467 185.526L241.607 184.211L241.679 186.002L241.476 187.376L242.059 188.229L243.231 189.04L243.792 190.461L244.019 191.074L247.981 190.423L251.878 187.75L249.023 175.116L247.481 161.475Z"
            fill="#0C6776"
          />
          <path
            d="M276.256 112.405L275.979 111.789L274.594 111.342L273.841 110.421L272.863 110.814L271.541 111.674L270.254 111.498L268.751 112.145L267.511 111.715L265.962 111.481L263.744 110.044L262.496 109.571L260.441 109.903L260.308 110.139L261.223 111.651L261.049 112.595L259.883 112.899L259.029 113.902L257.601 113.967L257.822 115.426L257.009 116.305L256.476 117.978L255.614 118.456L254.714 121.401L252.879 120.909L252.461 120.31L251.878 121.774L251.25 123.104L249.531 122.415L248.373 123.398L247.988 124.499L245.587 123.648L244.396 124.844L242.774 124.597L242.899 125.492L242.049 125.459L242.147 125.805L241.675 127.037L242.5 127.786L241.226 128.833L240.015 129.736L240.636 131.464L239.698 132.573L237.793 132.096L236.151 132.013L235.953 132.631L236.399 133.687L236.453 133.727L236.451 133.808L236.797 134.63L236.421 134.355L236.404 134.7L236.829 136.096L235.784 137.116L235.167 137.661L243.584 136.016L243.286 134.719L245.022 134.324L245.317 134.652L249.302 133.547L256.862 131.939L260.744 131.264L262.648 130.693L268.591 129.586L272.981 128.162L274.743 127.204L275.893 126.386L275.959 126.214L276.259 125.443L277.806 123.974L278.076 123.36L278.221 123.022L278.199 122.247L278.201 122.244L280.048 120.663L280.196 120.421L281.659 118.014L280.789 118.151L279.781 117.273L278.496 116.447L277.824 115.27L276.667 114.174L276.256 112.405Z"
            fill="#0C6776"
          />
          <path
            d="M234.006 137.889L234.146 137.862L235.429 136.733L236.235 135.948L235.877 134.769L235.915 133.984L234.716 133.108L233.975 133.5L232.54 131.349L232.541 130.028L231.735 128.282L231.094 128.177L229.042 126.699L228.297 126.808L226.641 125.794L225.376 124.624L225.551 122.896L225.924 121.595L226 120.152L224.765 119.233L223.679 119.966L222.609 119.679L222.215 118.182L221.444 116.8L220.861 116.56L219.095 115.662L217.576 114.426L216.172 112.857L215.12 110.342L215.312 108.267L214.428 107.778L213.066 106.7L206.211 108.002L198.825 109.182L193.061 110L187.588 110.701L187.684 111.003L187.689 111.018L188.893 112.174L190.075 113.174L191.114 114.813L192.666 115.662L193.649 115.511L194.091 117.021L193.406 118.647L193.929 119.286L194.921 120.868L196.826 121.451L198.017 130.66L199.172 139.423L199.208 139.419L199.666 143.299L207.691 142.265L215.195 141.108L222.344 139.901L230.301 138.996L231.266 140.175L230.004 142.396L229.868 142.864L233.682 142.144L233.803 140.205L233.983 138.927L233.994 138.428L233.359 138.552L234.005 137.985L234.006 137.889Z"
            fill="#0C6776"
          />
          <path
            d="M281.711 131.566L283.644 129.443L284.776 129.293L285.385 127.686L286.528 127.012L286.182 126.009L286.093 125.252L283.097 126.261L273.41 128.601L273.156 128.66L268.699 130.102L262.757 131.211L260.846 131.783L256.958 132.459L249.422 134.061L245.137 135.249L244.834 134.91L243.915 135.118L244.215 136.434L234.515 138.325L234.5 138.986L234.319 140.261L234.189 142.359L234.256 143.107L233.754 144.526L232.748 145.535L232.749 146.94L231.888 148.22L232.432 150.644L232.091 151.136L238.242 149.948L245.82 148.59L254.434 146.722L263.238 144.788L268.507 143.58L271.875 142.647L271.591 140.929L272.948 140.001L273.188 139.03L273.927 137.703L275.32 137.092L276.762 136.316L278.046 135.249L278.512 134.349L279.518 133.428L279.328 132.863L280.968 130.988L281.711 131.566Z"
            fill="#0C6776"
          />
          <path
            d="M289.14 123.887L297.47 121.703L310.52 117.591L317.376 115.201L323.963 112.85L320.411 108.598L317.859 105.235L312.371 102.17L312.314 102.158L312.288 102.124L312.265 102.093L311.658 101.29L310.867 101.896L309.761 101.723L309.53 101.689L309.53 101.686L309.584 100.675L309.656 99.3327L310.455 98.2343L310.364 97.6641L310.262 97.291L309.612 96.8511L308.205 96.3759L306.452 96.3315L306.636 95.2365L305.857 94.9956L305.12 95.0171L304.912 96.8549L301.052 95.7429L301.231 97.748L300.678 98.8724L299.778 100.338L299.084 101.89L298.562 101.711L297.985 103.998L297.911 104.868L297.906 104.927L297.815 104.995L296.893 105.673L296.89 105.673L295.662 105.369L295.64 105.362L294.913 105.109L294.858 106.751L294.21 108.527L294.263 109.857L294.211 109.938L293.324 111.334L292.91 112.883L293.288 113.741L293.391 114.686L293.382 114.693L293.383 114.702L292.407 115.801L291.478 115.954L290.825 116.824L290.178 116.766L290.236 117.374L290.233 117.375L290.235 117.387L287.754 118.939L286.826 118.601L285.053 120.176L283.685 119.736L282.664 119.167L282.161 118.2L281.025 120.051L280.42 121.036L280.421 121.039L280.418 121.039L278.731 122.482L278.754 123.123L278.561 123.56L278.242 124.286L276.705 125.754L276.463 126.365L276.323 126.724L276.32 126.727L275.001 127.665L274.981 127.677L282.951 125.754L286.033 124.716L286.031 124.701L286.245 124.647L286.541 124.546L286.543 124.567L289.14 123.887Z"
            fill="#0C6776"
          />
          <path
            d="M322.096 100.961L321.851 101.554L321.61 107.462L321.819 107.495L322.979 100.555L322.096 100.961Z"
            fill="#0C6776"
          />
          <path
            d="M272.244 143.089L268.638 144.085L263.66 145.227L267.808 154.803L271.46 162.621L273.093 164.953L274.165 166.405L273.325 168.229L273.57 170.851L274.336 172.319L274.527 173.884L274.663 175.229L275.331 176.124L275.928 177.018L277.465 178.861L284.64 177.43L296.781 175.502L297.597 176.634L298.03 176.031L297.218 173.092L298.238 172.405L299.884 172.621L301.177 172.389L301.167 167.463L302.405 160.836L301.354 160.781L300.457 160.642L299.982 158.965L298.927 157.726L297.241 157.16L297.315 156.389L296.687 155.648L295.699 153.994L293.031 152.973L291.667 151.239L289.664 150.364L288.905 149.471L285.982 148.189L284.73 146.918L282.802 144.722L281.521 144.539L279.077 143.568L279.861 141.427L280.066 141.101L277.389 141.781L272.244 143.089Z"
            fill="#0C6776"
          />
          <path
            d="M314.696 192.917L313.729 189.705L308.64 184.503L303.879 178.474L301.289 172.904L299.899 173.158L298.37 172.956L297.829 173.32L298.605 176.135L297.604 177.538L296.546 176.075L284.737 177.95L277.265 179.442L275.622 177.472L261.11 180.938L257.297 182.254L257.308 182.601L259.41 184.288L259.383 186.206L259.207 187.005L266.822 184.24L274.72 186.42L276.849 188.253L284.1 182.731L289.238 184.893L295.357 188.643L298.397 192.951L298.523 198.398L300.256 202.132L305.572 207.189L311.561 213.214L315.025 214.322L317.268 217.599L321.082 217.513L323.664 215.23L323.044 207.696L320.487 200.44L314.696 192.917Z"
            fill="#0C6776"
          />
          <path
            d="M195.262 84.4649L186.904 85.723L179.588 86.6053L179.777 88.3356L180.716 89.3839L180.673 90.4306L180.497 91.8758L180.196 93.1561L181.272 93.9452L181.363 94.7921L181.724 95.5656L182.308 96.9588L182.369 97.6135L183.681 99.0422L184.281 100.502L184.542 102.307L184.983 102.505L185.585 103.57L186.552 105.97L186.88 107.438L186.884 108.948L187.402 110.194L192.982 109.476L198.743 108.662L206.114 107.484L213.196 106.136L214.731 107.351L215.277 107.652L215.174 106.473L216.616 104.914L216.816 103.597L217.357 102.088L216.928 101.015L215.939 100.452L216.317 98.5807L218.527 97.7331L219.782 97.0392L220.057 96.4368L220.839 94.3891L220.762 92.2503L220.103 91.74L218.946 91.2281L218.489 90.3853L217.702 90.102L217.276 89.5912L217.264 89.5958L217.171 89.4642L216.89 89.1284L216.927 89.1208L216.391 88.3686L214.2 87.9205L213.507 86.5439L213.101 85.7663L212.75 83.9065L213.14 83.2498L212.199 82.1644L212.089 81.8762L204.229 83.0424L195.262 84.4649Z"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter0_d_378_1483)">
          <path
            d="M46.9805 41.4725C45.4993 41.5449 44.0332 41.1114 42.8448 40.2136C41.1258 38.914 38.6307 38.8168 36.7767 39.9771L35.8781 40.5392C35.719 40.6396 35.5185 40.6467 35.3523 40.5597C35.1859 40.4731 35.0781 40.3041 35.069 40.1169L34.6419 31.3772C34.6326 31.1857 34.7275 31.0048 34.8895 30.9032L35.7884 30.3405C38.0412 28.9296 40.9604 29.0466 43.0552 30.6297C44.4151 31.657 46.2975 31.954 47.9674 31.4033C48.1241 31.3507 48.2961 31.3759 48.4324 31.4696C48.5683 31.5634 48.6532 31.7149 48.6613 31.8801L49.0885 40.6192C49.1001 40.8572 48.9517 41.0727 48.7257 41.1474C48.1524 41.336 47.565 41.4433 46.9802 41.4724L46.9805 41.4725Z"
            fill="#FEC077"
          />
          <ellipse
            cx="35.8199"
            cy="51.7177"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 35.8199 51.7177)"
            fill="#BADED9"
          />
          <ellipse
            cx="35.8199"
            cy="51.7175"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 35.8199 51.7175)"
            fill="#0C6776"
          />
          <rect
            x="34.139"
            y="28.0752"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 34.139 28.0752)"
            fill="#0C6776"
          />
          <circle
            cx="34.6958"
            cy="28.1586"
            r="1.7112"
            transform="rotate(-2.79885 34.6958 28.1586)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter1_d_378_1483)">
          <path
            d="M29.0524 72.563C27.5712 72.6355 26.1051 72.2019 24.9167 71.3042C23.1977 70.0046 20.7026 69.9074 18.8486 71.0677L17.95 71.6298C17.7909 71.7302 17.5904 71.7373 17.4242 71.6502C17.2578 71.5636 17.15 71.3947 17.1409 71.2075L16.7138 62.4677C16.7045 62.2762 16.7994 62.0953 16.9614 61.9938L17.8603 61.4311C20.1131 60.0202 23.0323 60.1372 25.1271 61.7202C26.487 62.7475 28.3694 63.0446 30.0393 62.4939C30.196 62.4413 30.368 62.4665 30.5043 62.5602C30.6402 62.654 30.7251 62.8054 30.7332 62.9706L31.1604 71.7098C31.172 71.9478 31.0236 72.1633 30.7976 72.238C30.2243 72.4266 29.6369 72.5339 29.0521 72.5629L29.0524 72.563Z"
            fill="#FEC077"
          />
          <ellipse
            cx="17.8918"
            cy="82.8082"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 17.8918 82.8082)"
            fill="#BADED9"
          />
          <ellipse
            cx="17.8918"
            cy="82.8081"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 17.8918 82.8081)"
            fill="#0C6776"
          />
          <rect
            x="16.2108"
            y="59.166"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 16.2108 59.166)"
            fill="#0C6776"
          />
          <circle
            cx="16.7677"
            cy="59.2491"
            r="1.7112"
            transform="rotate(-2.79885 16.7677 59.2491)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter2_d_378_1483)">
          <path
            d="M25.5074 113.716C24.0263 113.789 22.5601 113.355 21.3718 112.457C19.6527 111.158 17.1577 111.06 15.3037 112.221L14.405 112.783C14.2459 112.883 14.0455 112.89 13.8793 112.803C13.7128 112.717 13.6051 112.548 13.5959 112.361L13.1689 103.621C13.1595 103.429 13.2545 103.248 13.4165 103.147L14.3153 102.584C16.5682 101.173 19.4874 101.29 21.5822 102.873C22.942 103.901 24.8245 104.198 26.4944 103.647C26.651 103.594 26.8231 103.62 26.9594 103.713C27.0953 103.807 27.1802 103.959 27.1882 104.124L27.6155 112.863C27.6271 113.101 27.4786 113.316 27.2526 113.391C26.6794 113.58 26.092 113.687 25.5072 113.716L25.5074 113.716Z"
            fill="#FEC077"
          />
          <ellipse
            cx="14.3468"
            cy="123.961"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 14.3468 123.961)"
            fill="#BADED9"
          />
          <ellipse
            cx="14.3469"
            cy="123.961"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 14.3469 123.961)"
            fill="#0C6776"
          />
          <rect
            x="12.6659"
            y="100.319"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 12.6659 100.319)"
            fill="#0C6776"
          />
          <circle
            cx="13.2228"
            cy="100.402"
            r="1.7112"
            transform="rotate(-2.79885 13.2228 100.402)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter3_d_378_1483)">
          <path
            d="M57.5048 157.3C56.0236 157.372 54.5575 156.939 53.3691 156.041C51.6501 154.741 49.155 154.644 47.301 155.804L46.4024 156.366C46.2433 156.467 46.0428 156.474 45.8766 156.387C45.7102 156.3 45.6024 156.131 45.5932 155.944L45.1662 147.204C45.1568 147.013 45.2518 146.832 45.4138 146.73L46.3127 146.168C48.5655 144.757 51.4847 144.874 53.5795 146.457C54.9394 147.484 56.8218 147.781 58.4917 147.23C58.6483 147.178 58.8204 147.203 58.9567 147.297C59.0926 147.391 59.1775 147.542 59.1856 147.707L59.6128 156.446C59.6244 156.684 59.476 156.9 59.2499 156.975C58.6767 157.163 58.0893 157.27 57.5045 157.3L57.5048 157.3Z"
            fill="#FEC077"
          />
          <ellipse
            cx="46.3442"
            cy="167.545"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 46.3442 167.545)"
            fill="#BADED9"
          />
          <ellipse
            cx="46.3442"
            cy="167.545"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 46.3442 167.545)"
            fill="#0C6776"
          />
          <rect
            x="44.6633"
            y="143.902"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 44.6633 143.902)"
            fill="#0C6776"
          />
          <circle
            cx="45.2201"
            cy="143.985"
            r="1.7112"
            transform="rotate(-2.79885 45.2201 143.985)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter4_d_378_1483)">
          <path
            d="M241.13 84.4214C239.649 84.4939 238.183 84.0603 236.994 83.1625C235.275 81.863 232.78 81.7658 230.926 82.9261L230.027 83.4882C229.868 83.5886 229.668 83.5957 229.502 83.5086C229.335 83.422 229.228 83.2531 229.218 83.0659L228.791 74.3261C228.782 74.1346 228.877 73.9537 229.039 73.8522L229.938 73.2894C232.191 71.8786 235.11 71.9956 237.205 73.5786C238.564 74.6059 240.447 74.903 242.117 74.3523C242.273 74.2997 242.446 74.3249 242.582 74.4186C242.718 74.5124 242.803 74.6638 242.811 74.829L243.238 83.5682C243.25 83.8061 243.101 84.0217 242.875 84.0964C242.302 84.285 241.714 84.3923 241.13 84.4213L241.13 84.4214Z"
            fill="#FEC077"
          />
          <ellipse
            cx="229.97"
            cy="94.6662"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 229.97 94.6662)"
            fill="#BADED9"
          />
          <ellipse
            cx="229.97"
            cy="94.666"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 229.97 94.666)"
            fill="#0C6776"
          />
          <rect
            x="228.289"
            y="71.0239"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 228.289 71.0239)"
            fill="#0C6776"
          />
          <circle
            cx="228.845"
            cy="71.107"
            r="1.7112"
            transform="rotate(-2.79885 228.845 71.107)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter5_d_378_1483)">
          <path
            d="M144.523 114.079C143.042 114.151 141.576 113.718 140.388 112.82C138.668 111.52 136.173 111.423 134.319 112.583L133.421 113.145C133.262 113.246 133.061 113.253 132.895 113.166C132.729 113.079 132.621 112.91 132.612 112.723L132.185 103.983C132.175 103.792 132.27 103.611 132.432 103.509L133.331 102.947C135.584 101.536 138.503 101.653 140.598 103.236C141.958 104.263 143.84 104.56 145.51 104.01C145.667 103.957 145.839 103.982 145.975 104.076C146.111 104.17 146.196 104.321 146.204 104.486L146.631 113.225C146.643 113.463 146.494 113.679 146.268 113.754C145.695 113.942 145.108 114.05 144.523 114.079L144.523 114.079Z"
            fill="#FEC077"
          />
          <ellipse
            cx="133.363"
            cy="124.323"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 133.363 124.323)"
            fill="#BADED9"
          />
          <ellipse
            cx="133.363"
            cy="124.323"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 133.363 124.323)"
            fill="#0C6776"
          />
          <rect
            x="131.682"
            y="100.681"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 131.682 100.681)"
            fill="#0C6776"
          />
          <circle
            cx="132.239"
            cy="100.764"
            r="1.7112"
            transform="rotate(-2.79885 132.239 100.764)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter6_d_378_1483)">
          <path
            d="M95.7759 151.608C94.2947 151.681 92.8286 151.247 91.6402 150.35C89.9212 149.05 87.4261 148.953 85.5721 150.113L84.6735 150.675C84.5144 150.776 84.3139 150.783 84.1477 150.696C83.9813 150.609 83.8735 150.44 83.8644 150.253L83.4373 141.513C83.428 141.322 83.5229 141.141 83.6849 141.039L84.5838 140.476C86.8366 139.066 89.7558 139.183 91.8507 140.766C93.2105 141.793 95.0929 142.09 96.7628 141.539C96.9195 141.487 97.0915 141.512 97.2279 141.606C97.3637 141.699 97.4486 141.851 97.4567 142.016L97.8839 150.755C97.8955 150.993 97.7471 151.209 97.5211 151.283C96.9478 151.472 96.3605 151.579 95.7756 151.608L95.7759 151.608Z"
            fill="#FEC077"
          />
          <ellipse
            cx="84.6153"
            cy="161.853"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 84.6153 161.853)"
            fill="#BADED9"
          />
          <ellipse
            cx="84.6153"
            cy="161.853"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 84.6153 161.853)"
            fill="#0C6776"
          />
          <rect
            x="82.9344"
            y="138.211"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 82.9344 138.211)"
            fill="#0C6776"
          />
          <circle
            cx="83.4913"
            cy="138.294"
            r="1.7112"
            transform="rotate(-2.79885 83.4913 138.294)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter7_d_378_1483)">
          <path
            d="M172.015 162.467C170.534 162.54 169.068 162.106 167.88 161.208C166.161 159.909 163.666 159.811 161.812 160.972L160.913 161.534C160.754 161.634 160.554 161.641 160.387 161.554C160.221 161.468 160.113 161.299 160.104 161.112L159.677 152.372C159.668 152.18 159.763 151.999 159.925 151.898L160.823 151.335C163.076 149.924 165.995 150.041 168.09 151.624C169.45 152.652 171.333 152.949 173.002 152.398C173.159 152.345 173.331 152.371 173.467 152.464C173.603 152.558 173.688 152.709 173.696 152.875L174.124 161.614C174.135 161.852 173.987 162.067 173.761 162.142C173.187 162.331 172.6 162.438 172.015 162.467L172.015 162.467Z"
            fill="#FEC077"
          />
          <ellipse
            cx="160.855"
            cy="172.712"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 160.855 172.712)"
            fill="#BADED9"
          />
          <ellipse
            cx="160.855"
            cy="172.712"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 160.855 172.712)"
            fill="#0C6776"
          />
          <rect
            x="159.174"
            y="149.07"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 159.174 149.07)"
            fill="#0C6776"
          />
          <circle
            cx="159.731"
            cy="149.153"
            r="1.7112"
            transform="rotate(-2.79885 159.731 149.153)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter8_d_378_1483)">
          <path
            d="M185.867 122.5C184.386 122.573 182.92 122.139 181.731 121.241C180.012 119.942 177.517 119.845 175.663 121.005L174.765 121.567C174.606 121.667 174.405 121.675 174.239 121.587C174.072 121.501 173.965 121.332 173.956 121.145L173.529 112.405C173.519 112.214 173.614 112.033 173.776 111.931L174.675 111.368C176.928 109.957 179.847 110.074 181.942 111.657C183.302 112.685 185.184 112.982 186.854 112.431C187.011 112.379 187.183 112.404 187.319 112.497C187.455 112.591 187.54 112.743 187.548 112.908L187.975 121.647C187.987 121.885 187.838 122.101 187.612 122.175C187.039 122.364 186.452 122.471 185.867 122.5L185.867 122.5Z"
            fill="#FEC077"
          />
          <ellipse
            cx="174.706"
            cy="132.745"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 174.706 132.745)"
            fill="#BADED9"
          />
          <ellipse
            cx="174.707"
            cy="132.745"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 174.707 132.745)"
            fill="#0C6776"
          />
          <rect
            x="173.026"
            y="109.103"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 173.026 109.103)"
            fill="#0C6776"
          />
          <circle
            cx="173.582"
            cy="109.186"
            r="1.7112"
            transform="rotate(-2.79885 173.582 109.186)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter9_d_378_1483)">
          <path
            d="M221.851 52.4459C220.37 52.5183 218.904 52.0847 217.716 51.187C215.997 49.8874 213.502 49.7902 211.648 50.9505L210.749 51.5126C210.59 51.613 210.389 51.6201 210.223 51.533C210.057 51.4465 209.949 51.2775 209.94 51.0903L209.513 42.3506C209.504 42.1591 209.598 41.9781 209.76 41.8766L210.659 41.3139C212.912 39.903 215.831 40.02 217.926 41.603C219.286 42.6303 221.168 42.9274 222.838 42.3767C222.995 42.3241 223.167 42.3493 223.303 42.443C223.439 42.5368 223.524 42.6882 223.532 42.8534L223.959 51.5926C223.971 51.8306 223.823 52.0461 223.597 52.1208C223.023 52.3094 222.436 52.4167 221.851 52.4458L221.851 52.4459Z"
            fill="#FEC077"
          />
          <ellipse
            cx="210.691"
            cy="62.6906"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 210.691 62.6906)"
            fill="#BADED9"
          />
          <ellipse
            cx="210.691"
            cy="62.6904"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 210.691 62.6904)"
            fill="#0C6776"
          />
          <rect
            x="209.01"
            y="39.0483"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 209.01 39.0483)"
            fill="#0C6776"
          />
          <circle
            cx="209.567"
            cy="39.1315"
            r="1.7112"
            transform="rotate(-2.79885 209.567 39.1315)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter10_d_378_1483)">
          <path
            d="M109.304 51.6802C107.823 51.7526 106.357 51.3191 105.169 50.4213C103.45 49.1218 100.955 49.0246 99.1007 50.1849L98.202 50.7469C98.0429 50.8474 97.8425 50.8545 97.6763 50.7674C97.5098 50.6808 97.4021 50.5119 97.3929 50.3247L96.9659 41.5849C96.9565 41.3934 97.0515 41.2125 97.2135 41.111L98.1123 40.5482C100.365 39.1374 103.284 39.2543 105.379 40.8374C106.739 41.8647 108.621 42.1618 110.291 41.6111C110.448 41.5585 110.62 41.5837 110.756 41.6774C110.892 41.7712 110.977 41.9226 110.985 42.0878L111.412 50.827C111.424 51.0649 111.276 51.2805 111.05 51.3551C110.476 51.5438 109.889 51.6511 109.304 51.6801L109.304 51.6802Z"
            fill="#FEC077"
          />
          <ellipse
            cx="98.1438"
            cy="61.9252"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 98.1438 61.9252)"
            fill="#BADED9"
          />
          <ellipse
            cx="98.1439"
            cy="61.9253"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 98.1439 61.9253)"
            fill="#0C6776"
          />
          <rect
            x="96.4629"
            y="38.283"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 96.4629 38.283)"
            fill="#0C6776"
          />
          <circle
            cx="97.0198"
            cy="38.3663"
            r="1.7112"
            transform="rotate(-2.79885 97.0198 38.3663)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter11_d_378_1483)">
          <path
            d="M90.1639 99.5315C88.6828 99.604 87.2166 99.1704 86.0283 98.2727C84.3092 96.9731 81.8142 96.8759 79.9602 98.0362L79.0615 98.5983C78.9024 98.6987 78.702 98.7058 78.5358 98.6187C78.3693 98.5321 78.2616 98.3632 78.2524 98.176L77.8254 89.4362C77.816 89.2448 77.911 89.0638 78.073 88.9623L78.9718 88.3996C81.2247 86.9887 84.1439 87.1057 86.2387 88.6887C87.5985 89.716 89.481 90.0131 91.1509 89.4624C91.3075 89.4098 91.4796 89.435 91.6159 89.5287C91.7518 89.6225 91.8367 89.7739 91.8447 89.9391L92.272 98.6783C92.2836 98.9163 92.1351 99.1318 91.9091 99.2065C91.3359 99.3951 90.7485 99.5024 90.1636 99.5315L90.1639 99.5315Z"
            fill="#FEC077"
          />
          <ellipse
            cx="79.0033"
            cy="109.777"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 79.0033 109.777)"
            fill="#BADED9"
          />
          <ellipse
            cx="79.0034"
            cy="109.777"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 79.0034 109.777)"
            fill="#0C6776"
          />
          <rect
            x="77.3225"
            y="86.1343"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 77.3225 86.1343)"
            fill="#0C6776"
          />
          <circle
            cx="77.8793"
            cy="86.2176"
            r="1.7112"
            transform="rotate(-2.79885 77.8793 86.2176)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter12_d_378_1483)">
          <path
            d="M277.359 110.25C275.878 110.323 274.412 109.889 273.223 108.991C271.504 107.692 269.009 107.595 267.155 108.755L266.257 109.317C266.098 109.417 265.897 109.425 265.731 109.337C265.565 109.251 265.457 109.082 265.448 108.895L265.021 100.155C265.011 99.9635 265.106 99.7826 265.268 99.6811L266.167 99.1183C268.42 97.7075 271.339 97.8244 273.434 99.4075C274.794 100.435 276.676 100.732 278.346 100.181C278.503 100.129 278.675 100.154 278.811 100.247C278.947 100.341 279.032 100.493 279.04 100.658L279.467 109.397C279.479 109.635 279.33 109.851 279.104 109.925C278.531 110.114 277.944 110.221 277.359 110.25L277.359 110.25Z"
            fill="#FEC077"
          />
          <ellipse
            cx="266.199"
            cy="120.495"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 266.199 120.495)"
            fill="#BADED9"
          />
          <ellipse
            cx="266.199"
            cy="120.495"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 266.199 120.495)"
            fill="#0C6776"
          />
          <rect
            x="264.518"
            y="96.853"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 264.518 96.853)"
            fill="#0C6776"
          />
          <circle
            cx="265.074"
            cy="96.9364"
            r="1.7112"
            transform="rotate(-2.79885 265.074 96.9364)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter13_d_378_1483)">
          <path
            d="M233.336 169.203C231.855 169.276 230.388 168.842 229.2 167.945C227.481 166.645 224.986 166.548 223.132 167.708L222.233 168.27C222.074 168.371 221.874 168.378 221.708 168.291C221.541 168.204 221.433 168.035 221.424 167.848L220.997 159.108C220.988 158.917 221.083 158.736 221.245 158.634L222.144 158.071C224.396 156.661 227.316 156.778 229.41 158.361C230.77 159.388 232.653 159.685 234.323 159.134C234.479 159.082 234.651 159.107 234.788 159.201C234.924 159.294 235.008 159.446 235.016 159.611L235.444 168.35C235.455 168.588 235.307 168.804 235.081 168.878C234.508 169.067 233.92 169.174 233.335 169.203L233.336 169.203Z"
            fill="#FEC077"
          />
          <ellipse
            cx="222.175"
            cy="179.448"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 222.175 179.448)"
            fill="#BADED9"
          />
          <ellipse
            cx="222.175"
            cy="179.448"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 222.175 179.448)"
            fill="#0C6776"
          />
          <rect
            x="220.494"
            y="155.806"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 220.494 155.806)"
            fill="#0C6776"
          />
          <circle
            cx="221.051"
            cy="155.889"
            r="1.7112"
            transform="rotate(-2.79885 221.051 155.889)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter14_d_378_1483)">
          <path
            d="M175.531 67.3755C174.05 67.448 172.584 67.0144 171.395 66.1167C169.676 64.8171 167.181 64.7199 165.327 65.8802L164.429 66.4423C164.27 66.5427 164.069 66.5498 163.903 66.4627C163.737 66.3761 163.629 66.2072 163.62 66.02L163.193 57.2802C163.183 57.0887 163.278 56.9078 163.44 56.8063L164.339 56.2436C166.592 54.8327 169.511 54.9497 171.606 56.5327C172.966 57.56 174.848 57.8571 176.518 57.3064C176.675 57.2538 176.847 57.279 176.983 57.3727C177.119 57.4665 177.204 57.6179 177.212 57.7831L177.639 66.5223C177.651 66.7603 177.502 66.9758 177.276 67.0505C176.703 67.2391 176.116 67.3464 175.531 67.3754L175.531 67.3755Z"
            fill="#FEC077"
          />
          <ellipse
            cx="164.371"
            cy="77.6205"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 164.371 77.6205)"
            fill="#BADED9"
          />
          <ellipse
            cx="164.371"
            cy="77.6206"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 164.371 77.6206)"
            fill="#0C6776"
          />
          <rect
            x="162.69"
            y="53.9783"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 162.69 53.9783)"
            fill="#0C6776"
          />
          <circle
            cx="163.246"
            cy="54.0616"
            r="1.7112"
            transform="rotate(-2.79885 163.246 54.0616)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter15_d_378_1483)">
          <path
            d="M296.005 148.418C294.523 148.491 293.057 148.057 291.869 147.159C290.15 145.86 287.655 145.763 285.801 146.923L284.902 147.485C284.743 147.585 284.543 147.593 284.376 147.505C284.21 147.419 284.102 147.25 284.093 147.063L283.666 138.323C283.657 138.131 283.752 137.951 283.914 137.849L284.813 137.286C287.065 135.875 289.985 135.992 292.079 137.575C293.439 138.603 295.322 138.9 296.992 138.349C297.148 138.296 297.32 138.322 297.457 138.415C297.592 138.509 297.677 138.661 297.685 138.826L298.113 147.565C298.124 147.803 297.976 148.019 297.75 148.093C297.177 148.282 296.589 148.389 296.004 148.418L296.005 148.418Z"
            fill="#FEC077"
          />
          <ellipse
            cx="284.844"
            cy="158.663"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 284.844 158.663)"
            fill="#BADED9"
          />
          <ellipse
            cx="284.844"
            cy="158.663"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 284.844 158.663)"
            fill="#0C6776"
          />
          <rect
            x="283.163"
            y="135.021"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 283.163 135.021)"
            fill="#0C6776"
          />
          <circle
            cx="283.72"
            cy="135.104"
            r="1.7112"
            transform="rotate(-2.79885 283.72 135.104)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter16_d_378_1483)">
          <path
            d="M319.469 183.751C317.987 183.823 316.521 183.389 315.333 182.492C313.614 181.192 311.119 181.095 309.265 182.255L308.366 182.817C308.207 182.918 308.007 182.925 307.84 182.838C307.674 182.751 307.566 182.582 307.557 182.395L307.13 173.655C307.121 173.464 307.216 173.283 307.378 173.181L308.276 172.619C310.529 171.208 313.448 171.325 315.543 172.908C316.903 173.935 318.786 174.232 320.455 173.681C320.612 173.629 320.784 173.654 320.92 173.748C321.056 173.841 321.141 173.993 321.149 174.158L321.577 182.897C321.588 183.135 321.44 183.351 321.214 183.425C320.64 183.614 320.053 183.721 319.468 183.75L319.469 183.751Z"
            fill="#FEC077"
          />
          <ellipse
            cx="308.308"
            cy="193.995"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 308.308 193.995)"
            fill="#BADED9"
          />
          <ellipse
            cx="308.308"
            cy="193.995"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 308.308 193.995)"
            fill="#0C6776"
          />
          <rect
            x="306.627"
            y="170.353"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 306.627 170.353)"
            fill="#0C6776"
          />
          <circle
            cx="307.184"
            cy="170.436"
            r="1.7112"
            transform="rotate(-2.79885 307.184 170.436)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter17_d_378_1483)">
          <path
            d="M332.171 57.0499C330.69 57.1223 329.223 56.6887 328.035 55.791C326.316 54.4914 323.821 54.3942 321.967 55.5545L321.068 56.1166C320.909 56.217 320.709 56.2241 320.542 56.137C320.376 56.0505 320.268 55.8815 320.259 55.6943L319.832 46.9546C319.823 46.7631 319.918 46.5821 320.08 46.4806L320.979 45.9179C323.231 44.507 326.151 44.624 328.245 46.207C329.605 47.2344 331.488 47.5314 333.158 46.9807C333.314 46.9281 333.486 46.9533 333.623 47.047C333.759 47.1408 333.843 47.2922 333.851 47.4575L334.279 56.1966C334.29 56.4346 334.142 56.6501 333.916 56.7248C333.343 56.9134 332.755 57.0207 332.17 57.0498L332.171 57.0499Z"
            fill="#FEC077"
          />
          <ellipse
            cx="321.01"
            cy="67.2948"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 321.01 67.2948)"
            fill="#BADED9"
          />
          <ellipse
            cx="321.01"
            cy="67.2946"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 321.01 67.2946)"
            fill="#0C6776"
          />
          <rect
            x="319.329"
            y="43.6523"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 319.329 43.6523)"
            fill="#0C6776"
          />
          <circle
            cx="319.886"
            cy="43.7357"
            r="1.7112"
            transform="rotate(-2.79885 319.886 43.7357)"
            fill="#0C6776"
          />
        </g>
        <g filter="url(#filter18_d_378_1483)">
          <path
            d="M316.229 93.2525C314.747 93.3249 313.281 92.8914 312.093 91.9936C310.374 90.694 307.879 90.5968 306.025 91.7571L305.126 92.3192C304.967 92.4197 304.767 92.4267 304.6 92.3397C304.434 92.2531 304.326 92.0841 304.317 91.8969L303.89 83.1572C303.881 82.9657 303.976 82.7848 304.138 82.6833L305.037 82.1205C307.289 80.7097 310.209 80.8266 312.303 82.4097C313.663 83.437 315.546 83.7341 317.216 83.1834C317.372 83.1307 317.544 83.1559 317.681 83.2497C317.816 83.3434 317.901 83.4949 317.909 83.6601L318.337 92.3993C318.348 92.6372 318.2 92.8528 317.974 92.9274C317.401 93.116 316.813 93.2234 316.228 93.2524L316.229 93.2525Z"
            fill="#FEC077"
          />
          <ellipse
            cx="305.068"
            cy="103.497"
            rx="5.03975"
            ry="2.79986"
            transform="rotate(-2.79885 305.068 103.497)"
            fill="#BADED9"
          />
          <ellipse
            cx="305.068"
            cy="103.497"
            rx="1.6836"
            ry="0.935334"
            transform="rotate(-2.79885 305.068 103.497)"
            fill="#0C6776"
          />
          <rect
            x="303.387"
            y="79.8547"
            width="1.0488"
            height="23.6808"
            rx="0.5244"
            transform="rotate(-2.79885 303.387 79.8547)"
            fill="#0C6776"
          />
          <circle
            cx="303.944"
            cy="79.9379"
            r="1.7112"
            transform="rotate(-2.79885 303.944 79.9379)"
            fill="#0C6776"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_378_1483"
          x="30.7842"
          y="24.7129"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_378_1483"
          x="12.8561"
          y="55.8035"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_378_1483"
          x="9.31116"
          y="96.9563"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_378_1483"
          x="41.3085"
          y="140.54"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_378_1483"
          x="224.934"
          y="67.6614"
          width="25.2422"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_378_1483"
          x="128.327"
          y="97.3186"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_378_1483"
          x="79.5796"
          y="134.848"
          width="25.2424"
          height="35.0156"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_378_1483"
          x="155.819"
          y="145.707"
          width="25.2424"
          height="35.0151"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_378_1483"
          x="169.671"
          y="105.74"
          width="25.2424"
          height="35.0156"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_378_1483"
          x="205.655"
          y="35.6858"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_378_1483"
          x="93.1082"
          y="34.9207"
          width="25.2424"
          height="35.0151"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d_378_1483"
          x="73.9677"
          y="82.772"
          width="25.2424"
          height="35.0151"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_d_378_1483"
          x="261.163"
          y="93.4907"
          width="25.2424"
          height="35.0151"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter13_d_378_1483"
          x="217.139"
          y="152.444"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter14_d_378_1483"
          x="159.335"
          y="50.616"
          width="25.2424"
          height="35.0151"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter15_d_378_1483"
          x="279.808"
          y="131.658"
          width="25.2423"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter16_d_378_1483"
          x="303.272"
          y="166.991"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter17_d_378_1483"
          x="315.974"
          y="40.29"
          width="25.2423"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
        <filter
          id="filter18_d_378_1483"
          x="300.032"
          y="76.4922"
          width="25.2424"
          height="35.0153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.46873" dy="1.73437" />
          <feGaussianBlur stdDeviation="1.73437" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_378_1483"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_378_1483"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
